import React, { useState, useEffect, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, cloneDeep } from "lodash";
import DatePickerT from "react-datepicker";
import { Button, message, Steps, theme, Tabs, Checkbox } from 'antd';
import moment from 'moment';
// import { DatePicker } from 'antd';
import { dayOfWeekMap, formFields, formFeildsDayPart, formFeildfacebookPageList, formFeildsAgeFromTo, formFeildAge, formFeildsTimeKey } from "./constant";
import Input from "../../../../../../../components/FormElements/Input";
import Select from "react-select";
import SelectNew from "../../../../../../../components/FormElements/SelectNew";
import SearchSelect from "../../../../../../../components/FormElements/SearchSelect";
import LocationSelect from "../../../../../../../components/FormElements/LocationSelect";
import DatepickerD from "../../../../../../../components/FormElements/Datepicker";
import adwords from '../../../../../../../assets/images/adwords.png';
import meta from '../../../../../../../assets/images/meta.png';
import dv360 from '../../../../../../../assets/images/dv360.png';
import tiktok from '../../../../../../../assets/images/tiktok.png';
import viads from "../../../../../../../assets/images/platformWhiteBgIcons/1x-Icons/vodafone.png";

import {
  handleFieldError,
  handleError,
} from "../../../../../../../utils/form-validation";
import { CSSTransition } from "react-transition-group";

import {
  getCategoryAction,
  getSUbCategoryAction,
  getDataConfigAction,
  getLanguageAction,
  getLocationAction,
  getAudienceAction,
  getThirdPartyAccountAction,
  postAddNewStrategyAction,
  dataConfigV2Action,
  pageListAction,
  getRecoAction,
  postFinalStrategyAction,
  getDataConfigListAction
} from "../../../../../../../actions";

import { useFetchPlatformData } from "../../../../../../../hooks/useFetchPlatformData";
import { setLocationReduxAction, strategyListReduxAction } from "../../../../../../../actions/strategyDetails";
import { strategyCreativeDataAction } from "../../../../../../../actions/creative";
import { withRouter } from "react-router-dom";
import { getCurrentDateInTimeZone, getDateFromUtcToSpecificZone, getUserSelectedDateInUtc, isApiCallSuccess, isDemoCampaign, isTenantDemoAdvertiser, updateConfigListDataWithDisplayName } from "../../../../../../../selectors";
import { reduxDrawerAction } from "../../../../../../../actions/campaign";
import { infoKeys } from "../../../../../../../helpers/config/infomateryKeys";
import asyncRoute from "../../../../../../../helpers/hoc/asyncRoute";
import { useFetchInfomateryData } from "../../../../../../../hooks/useFetchInfomateryData";
import { configKeys } from "../../../../../../../helpers/config/configKeys";
import { campaignList, dataConfig, recoCampaignCreativeData, recoCampaignDaypartList, recoTargetingList, thirdPartyData } from "../../../../../../../constants/demo/campaignData";

const Strategy = ({ isRecomendedPlanCampaign, targetTimeZone, isViewCampaign, ...props }) => {
  // console.log("props", props)

  const reduxInfoData = useFetchInfomateryData();

  const { strategyNext, setStrategyNext, next, fetchPreferenceEditDetails, fetchStrategyEditDetails, current } = props;
  const { TabPane } = Tabs;


  // console.log("id-props", props)
  // Create state variables for input values
  // const platformData = useFetchPlatformData();
  // console.log("platformData", platformData)
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({
    /* initial errors state */
  });
  const [submited, setSubmited] = useState(false);
  const [form, setForm] = useState({});
  const [biddingStrategy, setBiddingStrategy] = useState([]);
  const [seatData, setSeatData] = useState([]);
  const [fbPageData, setFbPageData] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [durationData, setDurationData] = useState([]);
  const [audData, setaudData] = useState([]);
  const [listAudienceData, setListAudience] = useState([]);
  const [selectedTab, setSelectedTab] = useState(audData.length > 0 ? audData[0] : null);
  const [responseBySearchTerm, setResponseBySearchTerm] = useState({});
  const [selectedAudienceState, setSelectedAudienceState] = useState({});
  const [locationPayload, setLocationPayload] = useState([]);
  const [audiencePayload, setAudiencePayload] = useState([]);
  const [keywordsData, setKeywordsData] = useState([]);
  const [sitesData, setSitesData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [pacingData, setPacingData] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  const [ageRangeData, setAgeRangeData] = useState([]);
  const [showFrequencyForm, setShowFrequencyForm] = useState(false);
  const [showLocationForm, setShowLocationForm] = useState(false);
  const [showAudienceForm, setShowAudienceForm] = useState(false);
  const [showKeywordsForm, setShowKeywordsForm] = useState(false);
  const [showSitesForm, setShowSitesForm] = useState(false);
  const [showFlightForm, setShowFlightForm] = useState(false);
  const [showPageForm, setShowPageForm] = useState(false);
  const [showOnScreenPositionForm, setShowOnScreenPositionForm] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedAudience, setSelectedAudience] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [selectedOptionFrequency, setSelectedOptionFrequency] = useState("none"); // You can initialize this state based on your requirements
  const [selectedOption, setSelectedOption] = useState("allDatesAndDayParts"); // You can initialize this state based on your requirements
  const [selectedOptionSites, setSelectedOptionSites] = useState("whiteList");
  const [showFbOptions, setShowFbOptions] = useState(false);
  const [strategyInfoData, setStrategyInfoData] = useState({})

  const [dayparts, setDayparts] = useState([
    {
      startTime: "",
      endTime: "",
      selectedDays: [],
      startDate: "",
      endDate: "",
    },
  ]);

  const [optionsData, setOptionsData] = useState({
    endTimeOptions: [],
    startTimeOptions: [],
  });

  const [locationData, setLocationData] = useState([]);
  const [ageFromOptions, setAgeFromOptions] = useState([]);
  const [ageToOptions, setAgeToOptions] = useState([]);
  const [selectedAgeFrom, setSelectedAgeFrom] = useState(null);
  const [selectedDevices, setDevice] = useState([]);
  const [selectedGenders, setGender] = useState([]);
  const [selectedLanguages, setLanguage] = useState([]);
  const [onScreenData, setOnScreenData] = useState([]);
  const [onScreenPositionDetails, setOnScreenPositionDetails] = useState({
    metaOnScreenPositionOptions: [],
    metaManualPositionOptions: {
      feeds: { messengerKey: "OnScreen_Position_Messenger_Feeds", instaKey: "OnScreen_Position_Instagram_Feeds", metaKey: 'OnScreen_Position_Facebook_Feeds', key: "OnScreen_Position_Feeds", title: 'Feeds', list: [] },
      stories: { messengerKey: "OnScreen_Position_Messenger_Stories_And_Reels", instaKey: "OnScreen_Position_Instagram_Stories_And_Reels", metaKey: 'OnScreen_Position_Facebook_Stories_And_Reels', key: "OnScreen_Position_Stories_And_Reels", title: 'Stories and Reels', list: [] },
      search: { instaKey: "OnScreen_Position_Instagram_Search_Results", metaKey: 'OnScreen_Position_Facebook_Search_Results', key: "OnScreen_Position_Search_Results", title: 'Search Results', list: [] },
      appSites: { audNetworkKey: "OnScreen_Position_Audience_Network_Apps_And_Sites", key: "OnScreen_Position_Apps_And_Sites", title: "Apps and Sites", list: [] },
      instreamAds: { metaKey: "OnScreen_Position_Facebook_Instream_Ads", key: "OnScreen_Position_Instream_Ads", title: "In-stream ads for videos and reels", list: [] },
      messages: { messengerKey: "OnScreen_Position_Messenger_Messages", key: "OnScreen_Position_Messages", title: "Messages", list: [] },
    },
    dv360PositionOptions: {
      onScreen: {
        display: { key: 'OnScreen_Position_DV360_Screen_Position_Display', list: [], title: 'Display' },
        video: { key: 'OnScreen_Position_DV360_Screen_Position_Video', list: [], title: 'Video' },
      },
      inContent: {
        inDisplay: { key: 'OnScreen_Position_DV360_Content_Position_Display', list: [], title: 'Display' },
        videoInStream: { key: 'OnScreen_Position_DV360_Conent_Position_Video_InStream', list: [], title: 'Video in-stream' },
        videoOutStream: { key: 'OnScreen_Position_DV360_Conent_Position_Video_OutStream', list: [], title: 'Video out-stream' }
      }
    },
    viadsPositionOptions: {
      display: { key: configKeys.OnScreen_Position_VIADS_Screen_Position_Display, list: [], title: 'Display' },
      video: { key: configKeys.OnScreen_Position_VIADS_Screen_Position_Video, list: [], title: 'Video' },
    },
    publisherPlatforms: []
  });
  const [dataConfigResponseData, setDataConfigResponseData] = useState({
    response: []
  });

  // console.log("selectedDevices", selectedDevices)
  // console.log("selectedOptionSites", selectedOptionSites)

  const tenantId = useSelector((state) =>
    get(state, "app.preSignInState.tenantId", "")
  );
  const userId = useSelector((state) =>
    get(state, "app.preSignInData.userId", "")
  );
  const authToken = useSelector((state) =>
    get(state, "app.signInData.authToken", "")
  );
  const reduxStrategyCreativeData = useSelector((state) =>
    get(state, "app.strategyCreativeData", "")
  );
  const preferenceData = useSelector((state) =>
    get(state, "app.preferenceData", "")
  );
  // const preferenceData = { "beki": [{ "startDate": "2024-02-23 00:00:00", "endDate": "2024-02-25 00:00:00", "status": 3, "name": "(MandateName)_(ads)_(content_type)", "stratgies": [{ "name": "(MandateName)_Ads_SearchStrategy 1", "id": 1296, "campaignId": 1094, "targeting": { "location": [{ "ads": "2356", "inex": 1, "beki": "55006" }, { "ads": "20458", "inex": 1, "beki": "55406" }, { "ads": "2360", "inex": 0, "beki": "55033" }], "audience": [{ "meta": "6012903127583", "value": "Food and restaurants", "type": 19, "inex": 1, "id": "618" }, { "meta": "94399502298", "value": "U.S. Food and Drug Administration", "type": 12, "inex": 1, "id": "942" }, { "meta": "93002", "value": "Food \u0026 Dining", "type": 1, "inex": 1, "id": "88814" }, { "meta": "92300", "value": "Foodies", "type": 1, "inex": 1, "id": "88818" }], "device": [{ "key": 1185, "value": "Desktop", "id": "1185", "inex": 1 }], "gender": [{ "key": 1190, "value": "Male", "id": "1190", "inex": 1 }], "age": 3162, "daypart": [], "languages": [{ "type": 0, "inex": 1, "beki": "2928" }, { "type": 0, "inex": 1, "beki": "1815" }], "keywords": { "values": ["food", "pood"], "inex": "1" }, "sites": { "values": ["https://stageatdv5.torcai.com/atd/campaign/add-campaign", "https://stageatdv5.torcai.com/atd/campai"], "inex": "1" }, "pageId": "110308628816469" }, "accountId": "170969429331356", "pacingType": 1176, "duration": 1174, "sDate": "2024-02-23 00:00:00", "eDate": "2024-02-25 00:00:00", "status": 3, "type": 2, "bidStrategy": 1170, "bidCap": 12, "freqCap": { "cap": 1, "time": 1, "interval": 1 } }] }] }
  // const preferenceStrategy = preferenceData.beki[0].stratgies[0];


  // console.log("preferenceData", preferenceData)

  const basicDetailsForm = useSelector(state => get(state, 'app.basicDetailsForm', {}));
  const strategyData = useSelector(state => get(state, 'app.strategyData', {}));

  // console.log("strategyData", strategyData)
  const InfoButton = asyncRoute(() => import('../../../../../../../components/InfoButton'));


  const callAddCase = () => {

    // console.log("reduxStrategyCreativeData", reduxStrategyCreativeData)
    if (Object.keys(reduxStrategyCreativeData).length > 0) {
      fetchPreferenceEditDetails();
    }
  }

  const isDemoAdvertiser = useMemo(() => {
    return isTenantDemoAdvertiser(tenantId);
  }, [tenantId]);

  useEffect(() => {
    if (
      reduxInfoData &&
      !Object.keys(strategyInfoData).length > 0
    ) {
      if (
        reduxInfoData.campaignScreen &&
        reduxInfoData.campaignScreen.beki &&
        reduxInfoData.campaignScreen.beki.strategyDetails
        && !Object.keys(strategyInfoData).length > 0
      ) {
        setStrategyInfoData(
          reduxInfoData.campaignScreen.beki.strategyDetails
        );
      }
    }
  }, [reduxInfoData]);

  useEffect(() => {
    const { match: { params: { id } } } = props;
    if (current == 2 && isRecomendedPlanCampaign && !id) {
      callAddCase()
    }
  }, [])


  useEffect(() => {
    const { match: { params: { id } } } = props;
    if (current == 2 && isRecomendedPlanCampaign && id) {
      initializeListApiCallEditReco();
    }
  }, [])


  const initializeListApiCallEditReco = async () => {
    const { match: { params: { id } } } = props;
    await fetchStrategyEditDetails(id)
    // await recoPlanApiFunction();
    await fetchPreferenceEditDetails(id);
  };

  const platformKeys = Object.keys(strategyData);
  // console.log("ccc-platformKeys", platformKeys); // Output: ["ads", "meta", "dv360","viads"]

  const creativeMappingKeys = { 0: ['display'], 1: ['video'], 2: ['search'], 3: ['display', 'video'] };
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log(onScreenPositionDetails, 'ON SCREEN POSITION DETAILS');
  }, [onScreenPositionDetails])

  useEffect(() => {
    // if (platformKeys && Array.isArray(platformKeys) && platformKeys.length > 0) {
    getOnScreenPositionDetails(form.dataConfig);
    // }
  }, [strategyData, form.dataConfig]);

  const handleAddRow = () => {
    setDayparts((prevDayparts) => [
      ...prevDayparts,
      {
        startTime: "",
        endTime: "",
        selectedDays: [],
        startDate: "",
        endDate: "",
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    setDayparts((prevDayparts) => {
      const updatedDayparts = [...prevDayparts];
      updatedDayparts.splice(index, 1);
      return updatedDayparts;
    });
  };

  const handleTimeChange = (index, timeType, value) => {
    setDayparts((prevDayparts) => {
      const updatedDayparts = [...prevDayparts];

      if (timeType == "startDate" || timeType == "endDate") {
        if (timeType == "startDate") {
          if (value.target.value > updatedDayparts[index].endDate) {
            updatedDayparts[index].endDate = ''
          }
        }
        else {
          if (value.target.value < updatedDayparts[index].startDate) {
            updatedDayparts[index].startDate = ''
          }
        }
        // Assuming you want to get the value from the target property
        updatedDayparts[index][timeType] = value.target.value;
      } else {
        // If it's not "start date" or "end date", directly set the value
        updatedDayparts[index][timeType] = value;
      }
      // console.log("updatedDayparts", updatedDayparts);
      return updatedDayparts;
    });
  };

  const handleDayChange = (index, day) => {
    setDayparts((prevDayparts) => {
      const updatedDayparts = [...prevDayparts];
      const selectedDays = updatedDayparts[index].selectedDays || []; // Initialize as an array if not already
      const dayIndex = selectedDays.indexOf(day);

      if (dayIndex !== -1) {
        // If the day is already selected, remove it
        selectedDays.splice(dayIndex, 1);
      } else {
        // If the day is not selected, add it
        selectedDays.push(day);
      }

      updatedDayparts[index].selectedDays = selectedDays;
      return updatedDayparts;
    });
  };

  const handleSelectChange = (selectedOptions, formKey) => {
    if (formKey === "location") {
      // setSelectedLocation(selectedOptions);
    } else if (formKey === "audience") {
      setSelectedAudience(selectedOptions);
    } else if (formKey === "keywords") {
      setSelectedKeywords(selectedOptions);
    } else if (formKey === "sites") {
      setSelectedSites(selectedOptions);
    } else if (formKey === "device") {
      setDevice(selectedOptions);
    } else if (formKey === "gender") {
      setGender(selectedOptions);
    } else if (formKey === "language") {
      setLanguage(selectedOptions);
    }
    // Add more conditions for other form keys if needed
  };

  const handleCheckboxChange = (option, checked) => {
    // console.log("vvv-option:", option);

    const newSelectedAudienceState = { ...selectedAudienceState };
    const selectedTabAudience = responseBySearchTerm[selectedTab] || [];

    // Update the individual checkbox state
    newSelectedAudienceState[selectedTab] = {
      ...newSelectedAudienceState[selectedTab],
      [option.id]: checked,
    };

    // Check if all individual checkboxes are checked
    const allChecked = selectedTabAudience.every(
      (audience) => newSelectedAudienceState[selectedTab] && newSelectedAudienceState[selectedTab][audience.id]
    );
    // console.log("444 selectedTab", selectedTab)
    // console.log("444 allChecked", allChecked)
    // console.log("vvv-selectedTabAudience:", selectedTabAudience);
    // console.log("vvv- newSelectedAudienceState[selectedTab]:", newSelectedAudienceState[selectedTab]);


    // Update the 'selectAll' checkbox state
    newSelectedAudienceState[selectedTab] = {
      ...newSelectedAudienceState[selectedTab],
      // selectAll: allChecked,
      [`selectAll`]: allChecked,
    };

    setSelectedAudienceState(newSelectedAudienceState);

    // Create audience payload based on the selected checkboxes
    const updatedAudiencePayload = [];
    const mappingKeys = {
      'ion': 2,
      'meta': 3,
      'ads': 4,
      'dv360': 5,
      'tiktok': 7,
      'viads': 8,
    };

    selectedTabAudience.forEach((audience) => {
      if (newSelectedAudienceState[selectedTab] && newSelectedAudienceState[selectedTab][audience.id]) {
        // console.log("vvv-newSelectedAudienceState[selectedTab][audience.id]", newSelectedAudienceState[selectedTab][audience.id])
        const platformId = option.platformId;
        const mappedPlatformKey = Object.keys(mappingKeys).find((key) => mappingKeys[key] == platformId);

        if (mappedPlatformKey) {
          updatedAudiencePayload.push({
            [mappedPlatformKey]: option.criterionId,
            // value: selectedTab,
            value: option.name,
            type: parseInt(option.type),
            adType: option.adType ? parseInt(option.adType) : null,
            inex: 1,
            id: option.id
          });
        }
        // console.log("444 updatedAudiencePayload", updatedAudiencePayload)
      }
    });

    setAudiencePayload(prevState => {
      // Create a Set to store unique IDs
      const uniqueIds = new Set();

      // Filter out duplicates based on the 'id' property
      const uniqueCampaigns = [...prevState, ...updatedAudiencePayload].filter(campaign => {
        // If the 'id' is already in the Set, return false to filter out the duplicate
        if (uniqueIds.has(campaign.id)) {
          return false;
        }
        // Otherwise, add the 'id' to the Set and return true to keep the entry
        uniqueIds.add(campaign.id);
        return true;
      });
      // console.log("vvv-uniqueCampaigns", uniqueCampaigns)
      return uniqueCampaigns;
    });
  }

  // Function to find the language value based on adwordsId
  const findLanguageValue = (languageConstants) => {
    // console.log(languageData, 'LANGUAGE DATA');
    // console.log(props.platformType, 'props.platformType');
    // console.log(languageConstants, 'languageConstants');
    const mappingKeys = {
      'ads': 'adwordsId',
      'dv360': 'adwordsId',
      'meta': 'metaId',
      'tiktok': 'tiktokId',
      'ion': 'ionId',
      'beki': 'bekiId'
      // Add more mappings as needed
    };

    // Get the mapping key based on the platformType
    const platformKey = mappingKeys["beki"];
    // console.log("platformKey", platformKey)

    const language = languageData.find((item) => item[platformKey] == languageConstants);
    // console.log("language", language)
    return language ? language : '';
  };

  const addPlatformTOList = (list, platform) => {
    return list.map((data) => ({ ...data, publisherPlatform: platform }))
  }

  const getOnScreenPositionDetails = async (data) => {
    // console.log("777 data", data)

    if (data && data.response.length > 0) {
      const findPlatform = {
        key: 3,
        value: "meta"
      }
      // if (platformKeys.includes("meta")) {
      let metaOnScreenPositionOptions = data.response.reduce((accumulator, item) => {
        // console.log("777 item",item)
        if (item.name == "Onscreen_Type" && item.platformId == findPlatform.key && item.list) {
          // console.log("777 item.name", item.name)
          // console.log("777 item.platformId", item.platformId)
          // console.log("777 item.list", item.list)
          accumulator = item.list.map(subItem => ({ ...subItem, value: subItem.name, label: subItem.name }));
          // console.log("777 accumulator", accumulator)

        }
        return accumulator;
      },
        // console.log("777 metaOnScreenPositionOptions", metaOnScreenPositionOptions),
        []);

      const { feeds, stories, search, messages, appSites, instreamAds } = onScreenPositionDetails.metaManualPositionOptions;
      let metaManualOnScreenFeedOptions = data.response.find(item => item.name == feeds.metaKey);
      let metaManualOnScreenStoriesOptions = data.response.find(item => item.name == stories.metaKey);
      let metaManualOnScreenSearchOptions = data.response.find(item => item.name == search.metaKey);

      // insta ***************

      let instaManualOnScreenFeedOptions = data.response.find(item => item.name == feeds.instaKey);
      let instaManualOnScreenStoriesOptions = data.response.find(item => item.name == stories.instaKey);
      let instaManualOnScreenSearchOptions = data.response.find(item => item.name == search.instaKey);

      // audNetwork *************

      let audNetworkAppSitesOptions = data.response.find(item => item.name == appSites.audNetworkKey);

      // messenger **************

      let messengerManualOnScreenStoriesOptions = data.response.find(item => item.name == stories.messengerKey);
      let messengerManualOnscreenFeedOptions = data.response.find(item => item.name == feeds.messengerKey);
      let messengerManualOnscreenMessagesOptions = data.response.find(item => item.name == messages.messengerKey);

      // instream ********************

      let metaManualOnScreenInstreamOptions = data.response.find(item => item.name == instreamAds.metaKey);

      // Publiser platform 

      let publiserPlatform = data.response.find(item => item.name == configKeys.Publisher_Platforms);


      setOnScreenPositionDetails((prev) => {
        return {
          ...prev,
          metaOnScreenPositionOptions: metaOnScreenPositionOptions,
          publisherPlatforms: publiserPlatform.list,
          metaManualPositionOptions: {
            feeds: {
              ...onScreenPositionDetails.metaManualPositionOptions.feeds,
              list: [...addPlatformTOList(metaManualOnScreenFeedOptions.list, 'facebook'), ...addPlatformTOList(instaManualOnScreenFeedOptions.list, 'instagram'), ...addPlatformTOList(messengerManualOnscreenFeedOptions.list, 'messenger')]
            },
            stories: {
              ...onScreenPositionDetails.metaManualPositionOptions.stories,
              list: [...addPlatformTOList(metaManualOnScreenStoriesOptions.list, 'facebook'), ...addPlatformTOList(instaManualOnScreenStoriesOptions.list, 'instagram'), ...addPlatformTOList(messengerManualOnScreenStoriesOptions.list, 'messenger')]
            },
            search: {
              ...onScreenPositionDetails.metaManualPositionOptions.search,
              list: [...addPlatformTOList(metaManualOnScreenSearchOptions.list, 'facebook'), ...addPlatformTOList(instaManualOnScreenSearchOptions.list, 'instagram')]
            },
            appSites: {
              ...onScreenPositionDetails.metaManualPositionOptions.appSites,
              list: [...addPlatformTOList(audNetworkAppSitesOptions.list, 'audience_network')]
            },
            messages: {
              ...onScreenPositionDetails.metaManualPositionOptions.messages,
              list: [...addPlatformTOList(messengerManualOnscreenMessagesOptions.list, 'messenger')]
            },
            instreamAds: {
              ...onScreenPositionDetails.metaManualPositionOptions.instreamAds,
              list: [...addPlatformTOList(metaManualOnScreenInstreamOptions.list, 'facebook')]
            }
          }
        }
      });
      // }
      // if (platformKeys.includes("dv360")) {
      const { display, video } = onScreenPositionDetails.dv360PositionOptions.onScreen;
      // console.log("888 display", display)
      // console.log("888 video", video)
      const { inDisplay, videoInStream, videoOutStream } = onScreenPositionDetails.dv360PositionOptions.inContent;
      let dv360DisplayOnScreenOptions = data.response.find(item => item.name == display.key);
      let dv360VideoOnScreenOptions = data.response.find(item => item.name == video.key);
      let dv360DisplayInContentOptions = data.response.find(item => item.name == inDisplay.key);
      let dv360VideoInStreamInContentOptions = data.response.find(item => item.name == videoInStream.key);
      let dv360VideoOutStreamInContentOptions = data.response.find(item => item.name == videoOutStream.key);


      const { display: { key: viDisplayKey }, video: { key: viVideoKey } } = onScreenPositionDetails.viadsPositionOptions;

      let viDisplayOnScreenOptions = data.response.find(item => item.name == viDisplayKey);
      let viVideoOnScreenOptions = data.response.find(item => item.name == viVideoKey);

      setOnScreenPositionDetails((prev) => {
        return {
          ...prev,
          dv360PositionOptions: {
            onScreen: {
              display: {
                ...display,
                list: dv360DisplayOnScreenOptions.list
              },
              video: {
                ...video,
                list: dv360VideoOnScreenOptions.list
              },
            },
            inContent: {
              inDisplay: {
                ...inDisplay,
                list: dv360DisplayInContentOptions.list
              },
              videoInStream: {
                ...videoInStream,
                list: dv360VideoInStreamInContentOptions.list
              },
              videoOutStream: {
                ...videoOutStream,
                list: dv360VideoOutStreamInContentOptions.list
              }
            }
          }
          ,
          viadsPositionOptions: {
            display: {
              ...prev.viadsPositionOptions.display,
              list: updateConfigListDataWithDisplayName(viDisplayOnScreenOptions && viDisplayOnScreenOptions.list || [])
            },
            video: {
              ...prev.viadsPositionOptions.video,
              list: updateConfigListDataWithDisplayName(viVideoOnScreenOptions && viVideoOnScreenOptions.list || [])
            }
          }
        }
      });
      // }
      //  else {

      // }
    }
    // console.log('HELLO WORLD!', data.response);
  };

  const handleChangeCheckBoxStories = (e, listData) => {
    const { checked } = e.target;
    if (checked) {
      const arrayIds = new Set(onScreenData.map(item => item.id));
      const nonDuplicateItems = listData.filter(firstItem => !arrayIds.has(firstItem.id));
      const mergedArray = [...onScreenData, ...nonDuplicateItems];
      setOnScreenData(mergedArray);
    }
    else {
      const listDataIds = new Set(listData.map(item => item.id));
      const filteredArray = onScreenData.filter(secondItem => !listDataIds.has(secondItem.id));
      setOnScreenData(filteredArray);
    }
  }

  const handleChangeCheckBoxPlatform = (e, platform) => {
    const { checked } = e.target;
    if (checked) {
      let platformData = [];
      const filteredArray = onScreenData.filter(data => data.publisherPlatform != platform);
      Object.keys(onScreenPositionDetails.metaManualPositionOptions).forEach((key) => {
        if (onScreenPositionDetails.metaManualPositionOptions[key] && onScreenPositionDetails.metaManualPositionOptions[key].list) {
          const filterPlatformData = onScreenPositionDetails.metaManualPositionOptions[key].list.filter((listData) => listData.publisherPlatform == platform);
          platformData = [...platformData, ...filterPlatformData]
        }
      })
      const mergedArray = [...filteredArray, ...platformData];
      setOnScreenData(mergedArray);
    }
    else {
      const filteredArray = onScreenData.filter(data => data.publisherPlatform != platform);
      setOnScreenData(filteredArray);
    }
  }

  const handleOnScreenPositions = (item, platformId) => {
    // console.log("qaz", item);
    // console.log("qaz", platformId);
    // console.log("qaz", onScreenData);

    // Clone the onScreenData array
    let updatedData = [...onScreenData];

    // Check if the item is already present in the array
    const isItemPresent = updatedData.some(screenPosition => screenPosition.id === item.id);

    if (isItemPresent) {
      // If the item is present, remove it
      updatedData = updatedData.filter(screenPosition => screenPosition.id !== item.id);
    } else {
      // If the item is not present, add it
      updatedData.push({ ...item, platformId }); // Include the platformId here
      // console.log(updatedData, 'qaz-UPDATED DATA');
    }

    // console.log(updatedData, 'qaz-UPDATED DATA');

    // Update the state with the modified array
    setOnScreenData(updatedData);
  };

  useEffect(() => {
    initializeListApiCall();

    form.frequencyCapPerInterval = 1

    if (props.setShowStepper) {
      props.setShowStepper(false);
    }

    if (props.screenType === "add") {
      dispatch(
        setLocationReduxAction({
          includedLocation: [],
          excludedLocation: []
        })
      );
    }
    // if (props.platformType != 'dv360') {
    //   formFields.frequencyCapTime.min = 1;
    //   formFields.frequencyCapTime.max = 999;
    // }
    if (platformKeys.includes("meta")) {
      setShowLocationForm(true)
      setShowPageForm(true)
    }
  }, []);

  useEffect(() => {
    if (preferenceData && preferenceData.beki && preferenceData.beki.length > 0 && preferenceData.beki[0].stratgies && preferenceData.beki[0].stratgies.length > 0) {
      const preferenceStrategy = preferenceData.beki[0].stratgies[0];


      if (preferenceStrategy.targeting && preferenceStrategy.targeting.daypart && preferenceStrategy.targeting.daypart.length > 0) {
        // console.log(preferenceStrategy.targeting.daypart,'propsForDaypart')
        const dayPartDataToSet = preferenceStrategy.targeting.daypart.map((data) => {
          const timeData = data.time.replaceAll(":", ".").split(',');
          const dayArray = getKeysByValues(dayOfWeekMap, data.day.split(','));
          // console.log(timeData ,'propsForDaypart');
          return {
            startTime: (timeData && timeData[0]) ? timeData[0] : '00:00',
            endTime: (timeData && timeData[1]) ? timeData[1] : '00:00',
            selectedDays: dayArray,
            startDate: data.startDate ? moment(
              getDateFromUtcToSpecificZone({
                date: data.startDate,
                targetTimeZone,
              })
            ).toDate() : '',
            endDate: data.endDate ? moment(
              getDateFromUtcToSpecificZone({
                date: data.endDate,
                targetTimeZone,
              })
            ).toDate() : '',
          }
        })
        // console.log(dayPartDataToSet, 'propsForDaypart');
        setDayparts(dayPartDataToSet);
        setSelectedOption("customSchedules")
        setShowFlightForm(true);
      }
      else {
        setSelectedOption("allDatesAndDayParts")
        // setShowFlightForm(true);
      }

      // const languageConstants = preferenceStrategy.targeting && preferenceStrategy.targeting.languages[0]["beki"]
      // console.log("languageConstants", languageConstants)


      const mappedPositionData = preferenceStrategy.targeting && preferenceStrategy.targeting.position
        ? preferenceStrategy.targeting.position.map(item => ({ id: item.key, name: item.value, platformId: item.platformId, publisherPlatform: item.publisherPlatform ? item.publisherPlatform : null }))
        : [];
      // console.log("mappedPositionData", mappedPositionData)
      if (mappedPositionData && mappedPositionData.length > 0) {
        if (platformKeys.includes("meta")) {
          let isMetaPosition = mappedPositionData.filter((dataOnScreen) => ('publisherPlatform' in dataOnScreen) && dataOnScreen.publisherPlatform !== null)
          if (isMetaPosition.length > 0) {
            form[formFields.onScreenFb.key] = 'Manual';
            setShowFbOptions(true);
          }
          else {
            form[formFields.onScreenFb.key] = 'Automatic';
            setShowFbOptions(false);
          }
        }
        setShowOnScreenPositionForm(true);
        setOnScreenData(mappedPositionData);
      }


      const mappedGenderData = preferenceStrategy.targeting && preferenceStrategy.targeting.gender
        ? preferenceStrategy.targeting.gender.map(item => ({ label: item.value, value: item.value, id: item.key }))
        : [];
      // console.log("mappedGenderData", mappedGenderData)
      setGender(mappedGenderData)

      const mappedDeviceData = preferenceStrategy.targeting && preferenceStrategy.targeting.device
        ? preferenceStrategy.targeting.device.map(item => ({ label: item.value, value: item.value, id: item.key }))
        : [];
      // console.log("mappedDeviceData", mappedDeviceData)
      setDevice(mappedDeviceData)
      // form.device = mappedDeviceData;

      const locationData = preferenceStrategy.targeting && preferenceStrategy.targeting.location ? preferenceStrategy.targeting.location : [];
      // console.log("locationData", locationData)
      setLocationPayload(locationData)
      if (locationData.length > 0) {
        setShowLocationForm(true) // Open Location if locationData is present
      }
      const includeLocations = locationData.filter(location => location.inex == 1);
      const excludeLocations = locationData.filter(location => location.inex == 0);

      // Function to create selection objects
      const createSelectionObject = location => ({
        label: location.value,
        value: location['beki'],
      });

      // Map location data for include selections
      const includeSelections = includeLocations.map(createSelectionObject);

      // Map location data for exclude selections
      const excludeSelections = excludeLocations.map(createSelectionObject);

      // Example output
      // console.log("Include Selections:", includeSelections);
      // console.log("Exclude Selections:", excludeSelections);
      dispatch(
        setLocationReduxAction({
          includedLocation: includeSelections,
          excludedLocation: excludeSelections
        })
      );

      const sitesEditData = preferenceStrategy.targeting && preferenceStrategy.targeting.sites ? preferenceStrategy.targeting.sites.values : [];
      if (sitesEditData && sitesEditData.length > 0) {
        const selectedSitesOptionsData = preferenceStrategy.targeting && preferenceStrategy.targeting.sites ? preferenceStrategy.targeting.sites.inex : '';
        setSitesData(sitesEditData)
        // console.log("selectedSitesOptionsData", selectedSitesOptionsData)
        setSelectedOptionSites(selectedSitesOptionsData ? "whiteList" : "blackList")
        setShowSitesForm(true)
      }





      const keyWordData = preferenceStrategy.targeting && preferenceStrategy.targeting.keywords && preferenceStrategy.targeting.keywords.values ? preferenceStrategy.targeting.keywords.values : [];

      // setKeywordsData(keyWordData)
      if (keyWordData && Array.isArray(keyWordData) && keyWordData.length > 0) {
        setKeywordsData(keyWordData);
        setShowKeywordsForm(true);
      }


      const freqCap = preferenceStrategy.freqCap && preferenceStrategy.freqCap
      // console.log("freqCap", freqCap);
      if (freqCap && (freqCap.interval !== 0 && freqCap.interval !== -1) && (freqCap.cap !== 0 && freqCap.cap !== -1)) {
        setSelectedOptionFrequency("limited");
        form.frequencyCapPerInterval = freqCap.interval;
        form.frequencyCapTo = freqCap.cap;
        setShowFrequencyForm(true);
      } else {
        setSelectedOptionFrequency("none");
      }


      form.sDate = preferenceStrategy.startDate ? moment(
        getDateFromUtcToSpecificZone({
          date: preferenceStrategy.startDate,
          targetTimeZone,
        })
      ).toDate() : preferenceStrategy.sDate ? moment(
        getDateFromUtcToSpecificZone({
          date: preferenceStrategy.sDate,
          targetTimeZone,
        })
      ).toDate() : '';
      form.eDate = preferenceStrategy.endDate ? moment(
        getDateFromUtcToSpecificZone({
          date: preferenceStrategy.endDate,
          targetTimeZone,
        })
      ).toDate() : preferenceStrategy.eDate ? moment(
        getDateFromUtcToSpecificZone({
          date: preferenceStrategy.eDate,
          targetTimeZone,
        })
      ).toDate() : '';
      form.budget = preferenceStrategy.budget;
      // form.bidcap = preferenceStrategy.name;
      form.biddingStrategy = preferenceStrategy.bidStrategy ? preferenceStrategy.bidStrategy : '';
      form.bidcap = preferenceStrategy.bidCap;
      form.pacing = preferenceStrategy.pacingType;
      form.duration = preferenceStrategy.duration;
      form.budget = preferenceStrategy.budget;
      form.audiencePayload = preferenceStrategy.targeting && preferenceStrategy.targeting.audience ? preferenceStrategy.targeting.audience : [];
      if (form.audiencePayload.length > 0) {
        setShowAudienceForm(true)
        setAudiencePayload(form.audiencePayload)
      }
      // form.gender = preferenceStrategy.targeting && preferenceStrategy.targeting.gender && preferenceStrategy.targeting.gender[0] && preferenceStrategy.targeting.gender[0].key || '';

      if (props.platformType === 'ads' || props.platformType === 'dv360') {
        form.ageGoogleAds = preferenceStrategy.targeting && preferenceStrategy.targeting.age || '';
      }
      setForm((prevForm) => {
        return {
          ...prevForm,
          ...form
        }
      })
    }
  }, [preferenceData, targetTimeZone])

  useEffect(() => {
    if (preferenceData && preferenceData.beki && preferenceData.beki.length > 0 && preferenceData.beki[0].stratgies && preferenceData.beki[0].stratgies.length > 0) {
      const preferenceStrategy = preferenceData.beki[0].stratgies[0];
      if (preferenceStrategy && preferenceStrategy.targeting && preferenceStrategy.targeting.age) {
        // console.log("qwe-preferenceStrategy.targeting.age", preferenceStrategy.targeting.age)
        const filteredAgeRangeData = ageRangeData.filter(item => item.id == preferenceStrategy.targeting.age);
        // console.log("qwe-filteredAgeRangeData", filteredAgeRangeData)

        if (filteredAgeRangeData.length > 0) {
          const selectedAgeFrom = parseInt(filteredAgeRangeData[0].value.split('-')[0]);
          const selectedAgeTo = parseInt(filteredAgeRangeData[0].value.split('-')[1]);

          setForm((prevForm) => {
            return {
              ...prevForm,
              [formFeildsAgeFromTo.ageFrom.key]: selectedAgeFrom.toString(),
              [formFeildsAgeFromTo.ageTo.key]: selectedAgeTo.toString(),
            }
          })
          setSelectedAgeFrom(selectedAgeFrom); // used to set ageFromOptions with useEffect below


        }
      }
    }
  }, [ageRangeData, preferenceData]);

  const getKeysByValues = (object, values) => {
    // console.log(object,values,'propsForDaypart')
    let keys = [];
    for (let prop in object) {
      if (object.hasOwnProperty(prop)) {
        if (values.includes(object[prop].toString()))
          keys.push(prop);
      }
    }
    return keys;
  }

  useEffect(() => {
    if (form.audiencePayload && form.audiencePayload.length > 0) {
      setShowAudienceForm(true)
      // setAudiencePayload(form.audiencePayload)
    }
  }, [responseBySearchTerm])


  useEffect(() => {
    if (form.audiencePayload && form.audiencePayload.length > 0) {
      const newSelectedAudienceState = { ...selectedAudienceState };
      // console.log("www-newSelectedAudienceState", newSelectedAudienceState)
      // console.log("www-responseBySearchTerm", responseBySearchTerm)

      // Iterate through each key in responseBySearchTerm
      for (const key in responseBySearchTerm) {
        if (Object.hasOwnProperty.call(responseBySearchTerm, key)) {
          const element = responseBySearchTerm[key];
          // console.log("www-element", element)

          element.forEach(element => {
            // console.log("www-element", element)
            // console.log("www-form.audiencePayload", form.audiencePayload)
            // const selectedIds = form.audiencePayload.filter(item => (element.criterionId == item.id && element.type == item.type));
            const selectedIds = form.audiencePayload.filter(item => {
              const idProperty = platformKeys.find(key => item[key]); // Find the first key in platformKeys that exists in item
              return idProperty && element.criterionId == item[idProperty] && element.type == item.type;
            });

            // console.log("www-selectedIds", selectedIds)

            // Set selected IDs to true in newSelectedAudienceState
            if (selectedIds.length > 0) {
              if (!newSelectedAudienceState[key]) {
                newSelectedAudienceState[key] = {};
              }
              selectedIds.forEach(selectedId => {
                newSelectedAudienceState[key][element.id] = true; // Assuming selectedId is an object with an id property
              });
            }
          });

        }
      }

      // console.log("www-newSelectedAudienceState", newSelectedAudienceState)

      // Update the state with the modified newSelectedAudienceState
      setSelectedAudienceState(newSelectedAudienceState);
    }
  }, [form.audiencePayload, responseBySearchTerm]);


  useEffect(() => {
    if (preferenceData && preferenceData.beki && preferenceData.beki.length > 0 && preferenceData.beki[0].stratgies && preferenceData.beki[0].stratgies.length > 0) {
      const preferenceStrategy = preferenceData.beki[0].stratgies[0];
      if (languageData && languageData.length > 0 && preferenceStrategy.targeting && preferenceStrategy.targeting.languages) {
        const languages = preferenceStrategy.targeting.languages.map(language => findLanguageValue(language["beki"]));
        setLanguage(languages);
      }
    }
  }, [languageData, preferenceData]);

  useEffect(() => {
    if (preferenceData && preferenceData.beki && preferenceData.beki.length > 0 && preferenceData.beki[0].stratgies && preferenceData.beki[0].stratgies.length > 0) {
      const preferenceStrategy = preferenceData.beki[0].stratgies[0];
      if (preferenceStrategy && preferenceData.beki[0].accountId) {
        const accountValue = preferenceData.beki[0].accountId
        form.fbPageAccount = accountValue;
        // form.fbPageList = preferenceStrategy.targeting && preferenceStrategy.targeting.pageId || '';
        form.fbPageList = preferenceStrategy.targeting && preferenceStrategy.targeting.page && preferenceStrategy.targeting.page.length > 0 && preferenceStrategy.targeting.page[0].key || '';

        setForm((prevForm) => {
          return {
            ...prevForm,
            ...form
          }
        })
        setShowPageForm(true)

        const filterSeat = seatData.filter((cat) => {
          return cat.accountId == accountValue;
        });
        if (filterSeat.length > 0) {
          filterSeat.map(data => {
            pageListFunction(data)
          })
        }
      }
    }
  }, [seatData, preferenceData]);


  useEffect(() => {
    recoPlanApiFunction();
  }, [strategyData])

  const initializeListApiCall = async () => {
    // await recoPlanApiFunction();
    await thirdPartyAccount();
    await dataConfigApiFunction();

  };

  // Function to initialize age options
  useEffect(() => {
    if (ageRangeData.length > 0) {
      // console.log("ageRangeData", ageRangeData)
      const ageValues = Array.from(new Set(ageRangeData.map(item => parseInt(item.value.split('-')[0])))).sort((a, b) => a - b);
      const ageFromOptions = ageValues.map(value => ({ id: `${value}`, name: `${value}` }));
      setAgeFromOptions(ageFromOptions);
      // console.log('Initialized ageFromOptions:', ageFromOptions);
    }
  }, [ageRangeData]);

  useEffect(() => {
    if (selectedAgeFrom !== null) {
      // console.log('Selected Age From:', selectedAgeFrom);
      // console.log('ageRangeData', ageRangeData);

      const matchingItems = ageRangeData.filter(item => item.value.startsWith(`${selectedAgeFrom}-`));

      // console.log('Matching Items:', matchingItems);

      const ageToOptions = matchingItems.map(item => ({ id: `${item.value.split('-')[1]}`, name: `${item.value.split('-')[1]}` }));
      setAgeToOptions(ageToOptions);

      // console.log('Updated ageToOptions:', ageToOptions);
    }
  }, [selectedAgeFrom, ageRangeData]);


  const dataConfigApiFunction = async () => {
    let params = { list: 'all' };
    await dispatch(getDataConfigListAction({ tenantId, authToken, userId, params }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          response,
        } = data;

        // debugger;
        if (status === "Success") {
          setDataConfigResponseData(data);
          form.dataConfig = data;

          const findPlatform = {
            "key": 1,
            "value": "beki"
          }

          const pacingResponse = response.filter(item =>
            item.name == "Pacing_Type"
          );

          const biddingStrategy = response.filter(item =>
            item.name == "Bidding_Strategy"
          );

          const durationResponse = response.filter(item =>
            item.name == "Duration_Type"
          );


          if (pacingResponse) {
            if (findPlatform) {
              const findPacingDataForPlatform = pacingResponse.find((dataPac) => dataPac.platformId == findPlatform.key);
              if (findPacingDataForPlatform) {
                setPacingData(updateConfigListDataWithDisplayName(findPacingDataForPlatform.list))
                form.pacing = findPacingDataForPlatform.list[0].id
              }
            }
          }

          if (biddingStrategy) {
            if (findPlatform) {
              const findBiddingStratForPlatform = biddingStrategy.find((dataBid) => dataBid.platformId == findPlatform.key);
              if (findBiddingStratForPlatform) {
                setBiddingStrategy(updateConfigListDataWithDisplayName(findBiddingStratForPlatform.list))
              }
            }
          }

          if (durationResponse) {
            if (findPlatform) {
              const findDurationForPlatform = durationResponse.find((dataDur) => dataDur.platformId == findPlatform.key);
              if (findDurationForPlatform) {
                setDurationData(updateConfigListDataWithDisplayName(findDurationForPlatform.list))
                form.duration = findDurationForPlatform.list[0].id
              }
            }
          }

          setForm((prevForm) => {
            return {
              ...prevForm,
              ...form
            }
          })



        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleTouch = (e) => {
    const { name, value } = e.target;
    const { error } = handleFieldError(value, formFields[name]);
    setErrors({ ...errors, [name]: error });
    setTouched({ ...touched, [name]: true });
  };

  const handleChange = (e) => {
    const { value, name, min } = e.target;

    if (name == "onScreenFb") {
      if (value.toLowerCase() == "manual") {
        const { metaManualPositionOptions:
          { feeds: { list: feedsList },
            stories: { list: storiesList },
            search: { list: searchList },
            appSites: { list: appSiteList },
            messages: { list: messagesList },
            instreamAds: { list: instreamList }
          } } = onScreenPositionDetails;
        const mergedData = [...onScreenData, ...feedsList, ...storiesList, ...searchList, ...appSiteList, ...messagesList, ...instreamList];
        setOnScreenData(mergedData);
        setShowFbOptions(true);
      } else {
        const filterDataOnScreen = onScreenData.filter((dataOnScreen) => !('publisherPlatform' in dataOnScreen) || dataOnScreen.publisherPlatform === null);
        setOnScreenData(filterDataOnScreen);
        setShowFbOptions(false);
      }
    }
    if (name == "ageFrom") {
      setSelectedAgeFrom(value);
    }

    if (name == "sDate") {
      if (value > form.eDate) {
        setForm((prev) => { return { ...prev, eDate: '' } });
      }
    }
    if (name == "eDate") {
      if (value < form.sDate) {
        setForm((prev) => { return { ...prev, sDate: '' } });
      }
    }

    const accountValue = e.target.value;
    const filterSeat = seatData.filter((cat) => {
      return cat.accountId == accountValue;
    });
    // console.log("filterSeat", filterSeat)
    // console.log("accountValue", accountValue)
    if (filterSeat.length > 0) {
      filterSeat.map(data => {
        pageListFunction(data)
      })
    }
    setForm((prev) => { return { ...prev, [name]: value } });
  };

  const thirdPartyAccount = async () => {
    // console.log("here");

    if (isDemoAdvertiser) {
      const { match: { params: { id } } } = props;
      if (isDemoCampaign(campaignList, id)) {
        const {
          responseCode: { status = "" },
          responseObj,
        } = thirdPartyData;

        let seatData = [];

        if (responseObj) {
          // Check platformType and set seatData accordingly
          switch (props.platformType) {
            case 'ads':
              seatData = responseObj.googleadwords || [];
              break;
            case 'beki':
              seatData = responseObj.meta || [];
              break;
            case 'dv360':
              seatData = responseObj.dv360 || [];
              break;
            case 'tiktok':
              seatData = responseObj.tiktok || [];
              break;
            default:
            // console.error(`Unhandled platformType: ${props.platformType}`);
          }
        } else {
          console.error("responseObj not found in API response");
        }

        setSeatData(seatData);
        return
      }
    }

    try {
      const data = await dispatch(getThirdPartyAccountAction({ tenantId, authToken, userId }));

      const {
        responseCode: { status = "" },
        responseObj,
      } = data;
      // console.log("data", data)


      if (status === "Success") {
        let seatData = [];
        // console.log("responseObj", responseObj)

        if (responseObj) {
          // Check platformType and set seatData accordingly
          switch (props.platformType) {
            case 'ads':
              seatData = responseObj.googleadwords || [];
              break;
            case 'beki':
              seatData = responseObj.meta || [];
              break;
            case 'dv360':
              seatData = responseObj.dv360 || [];
              break;
            case 'tiktok':
              seatData = responseObj.tiktok || [];
              break;
            default:
            // console.error(`Unhandled platformType: ${props.platformType}`);
          }
        } else {
          console.error("responseObj not found in API response");
        }

        setSeatData(seatData);
      } else {
        console.log("List data not found");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const pageListFunction = async (data) => {

    const payload = {
      BekiAccountId: data.BekiAccountId,
      accountId: data.accountId
    }

    await dispatch(pageListAction({ tenantId, authToken, userId, payload })).then((data) => {
      // console.log("new a", cateID);
      // console.log("data", data)
      const {
        responseCode: { status = "" },
        response,
      } = data;

      if (status == "Success") {
        const subCategoryListDropdownData = response.map((item, index) => {
          return { name: item.pageName, id: item.id };
        });
        setFbPageData(subCategoryListDropdownData);
      } else {
        console.log("List data not found");
      }
    })
      .catch((error) => {
        console.error(error);
      });
  }

  const recoPlanApiFunction = async () => {
    const mappingKeys = {
      'ion': 2,
      'meta': 3,
      'ads': 4,
      'dv360': 5,
      'tiktok': 7,
      'viads': 8,
    };

    const channel = platformKeys.map(platform => mappingKeys[platform]);
    const uniqueChannels = [...new Set(channel)]; // Remove duplicates
    uniqueChannels.sort((a, b) => a - b); // Sort in ascending order


    const params = {
      recoplan: "masterdata",
      channel: uniqueChannels.join(',') // Set the channel based on platformKeys without duplicates
    };

    if (platformKeys.length > 0) {

      if (isDemoAdvertiser) {
        const { match: { params: { id } } } = props;
        if (isDemoCampaign(campaignList, id)) {
          if (props.location.pathname.includes("edit-campaign") || props.location.pathname.includes("view-campaign")) {
            const {
              responseCode: { status = "" },
              responseObj,
            } = recoTargetingList;

            if (status === "Success") {
              if (responseObj.language) {
                const listLanguage = responseObj.language.map((data) => {
                  return {
                    ...data,
                    label: data.value,
                    value: data.value
                  }
                })
                setLanguageData(listLanguage)
              }
              if (responseObj.device) {
                const listDevice = responseObj.device.map((data) => {
                  return {
                    ...data,
                    label: data.value,
                    value: data.value
                  }
                })
                setDeviceData(listDevice)
              }
              if (responseObj.age) {
                setAgeRangeData(responseObj.age)
                // Extract unique age values and sort them
                const ageValues = Array.from(new Set(responseObj.age.map(item => parseInt(item.value.split('-')[0])))).sort((a, b) => a - b);

                // Create options for ageFrom
                const ageFromOptions = ageValues.map(value => ({ id: `${value}`, name: `${value}` }));
                setAgeFromOptions(ageFromOptions);
              }
              if (responseObj.gender) {
                const listGender = responseObj.gender.map((data) => {
                  return {
                    ...data,
                    label: data.value,
                    value: data.value
                  }
                })
                setGenderData(listGender)
              }
              // console.log("status", status)

            } else {
              console.log("List data not found");
            }

            return;
          }
        }
      }

      await dispatch(getRecoAction({ tenantId, authToken, userId, params }))
        .then((data) => {
          // console.log("111 data", data)
          const {
            responseCode: { status = "" },
            responseObj,
          } = data;

          if (status === "Success") {
            if (responseObj.language) {
              const listLanguage = responseObj.language.map((data) => {
                return {
                  ...data,
                  label: data.value,
                  value: data.value
                }
              })
              setLanguageData(listLanguage)
            }
            if (responseObj.device) {
              const listDevice = responseObj.device.map((data) => {
                return {
                  ...data,
                  label: data.value,
                  value: data.value
                }
              })
              setDeviceData(listDevice)
            }
            if (responseObj.age) {
              setAgeRangeData(responseObj.age)
              // Extract unique age values and sort them
              const ageValues = Array.from(new Set(responseObj.age.map(item => parseInt(item.value.split('-')[0])))).sort((a, b) => a - b);

              // Create options for ageFrom
              const ageFromOptions = ageValues.map(value => ({ id: `${value}`, name: `${value}` }));
              setAgeFromOptions(ageFromOptions);
            }
            if (responseObj.gender) {
              const listGender = responseObj.gender.map((data) => {
                return {
                  ...data,
                  label: data.value,
                  value: data.value
                }
              })
              setGenderData(listGender)
            }
            // console.log("status", status)

          } else {
            console.log("List data not found");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }

  };

  const handleAddFormClick = (formKey, setShowForm) => {
    setShowForm((prevShowForm) => !prevShowForm);
  };

  const handleRemoveOption = (removedOption, formKey) => {
    // Handle the removal of the option based on the form key
    if (formKey === "location") {
      setSelectedLocation((prevSelected) =>
        prevSelected.filter((option) => option.value !== removedOption.value)
      );
    } else if (formKey === "audience") {
      setSelectedAudience((prevSelected) =>
        prevSelected.filter((option) => option.value !== removedOption.value)
      );
    } else if (formKey === "keywords") {
      setSelectedKeywords((prevSelected) =>
        prevSelected.filter((option) => option.value !== removedOption.value)
      );
    }
    // Add more conditions for other form keys if needed
  };

  const handleSelectAllChange = (checked, platform) => {
    const newSelectedAudienceState = { ...selectedAudienceState };
    const selectedTabAudience = responseBySearchTerm[selectedTab] || [];


    // Update the individual checkbox state for the filtered audience options
    selectedTabAudience.forEach((option) => {
      newSelectedAudienceState[selectedTab] = {
        ...newSelectedAudienceState[selectedTab],
        [option.id]: checked,
      };
    });

    // console.log("000 selectedTab", selectedTab)
    // console.log("000 selectedTabAudience:", selectedTabAudience);
    // console.log("000 newSelectedAudienceState[selectedTab]:", newSelectedAudienceState[selectedTab]);
    // console.log("000 payload:", payload);

    // Set the 'selectAll' property for the selected tab
    newSelectedAudienceState[selectedTab] = {
      ...newSelectedAudienceState[selectedTab],
      [`selectAll`]: checked, // Use a separate key for each platform's "Select All" checkbox
    };

    // Update the state with the new payload
    setSelectedAudienceState(newSelectedAudienceState);


    // Generate payload for the filtered audience options
    const payload = [...audiencePayload];
    const mappingKeys = {
      'ion': 2,
      'meta': 3,
      'ads': 4,
      'dv360': 5,
      'tiktok': 7,
      'viads': 8,
    };

    selectedTabAudience.forEach((option) => {
      if (newSelectedAudienceState[selectedTab] && newSelectedAudienceState[selectedTab][option.id]) {
        const platformId = option.platformId;
        const mappedPlatformKey = Object.keys(mappingKeys).find((key) => mappingKeys[key] == platformId);

        if (mappedPlatformKey) {
          payload.push({
            [mappedPlatformKey]: option.criterionId,
            // value: selectedTab,
            value: option.name,
            type: parseInt(option.type),
            adType: option.adType ? parseInt(option.adType) : null,
            inex: 1,
            id: option.id
          });
        }
        // console.log("000 payload", payload)
      }
    });




    // Use the generated payload as needed
    // setAudiencePayload(payload); // Update audiencePayload state


    // prevState => {
    //   // Create a copy of the state array
    //   const campaigns = [...prevState];
    //   // Replace the array at the specified index with the new array
    //   campaigns[index] = newArray;
    //   // console.log(campaigns, "XXX", prevState, "index", index)
    //   return campaigns;

    if (payload.length > 0) {
      setAudiencePayload(prevState => {
        // Create a Set to store unique IDs
        const uniqueIds = new Set();

        // Filter out duplicates based on the 'id' property
        const uniqueCampaigns = [...prevState, ...payload].filter(campaign => {
          // If the 'id' is already in the Set, return false to filter out the duplicate
          if (uniqueIds.has(campaign.id)) {
            return false;
          }
          // Otherwise, add the 'id' to the Set and return true to keep the entry
          uniqueIds.add(campaign.id);
          return true;
        });

        return uniqueCampaigns;
      });
    }
    else {
      setAudiencePayload(payload); // Update audiencePayload state
    }

    // setAudiencePayload(prevState => {
    //   // Create a Set to store unique IDs
    //   const uniqueIds = new Set();

    //   // Filter out duplicates based on the 'id' property
    //   const uniqueCampaigns = [...prevState, ...payload].filter(campaign => {
    //     // If the 'id' is already in the Set, return false to filter out the duplicate
    //     if (uniqueIds.has(campaign.id)) {
    //       return false;
    //     }
    //     // Otherwise, add the 'id' to the Set and return true to keep the entry
    //     uniqueIds.add(campaign.id);
    //     return true;
    //   });

    //   return uniqueCampaigns;
    // });

  };

  useEffect(() => {
    // Create an array to store IDs with value 'false'
    const falseIds = [];

    // Iterate through each element in selectedAudienceState
    for (const key in selectedAudienceState) {
      if (Object.hasOwnProperty.call(selectedAudienceState, key)) {
        const element = selectedAudienceState[key];

        // Iterate through each ID in the element
        for (const id in element) {
          if (Object.hasOwnProperty.call(element, id) && element[id] === false) {
            // If the value is 'false', add the ID to the falseIds array
            falseIds.push(id);
          }
        }
      }
    }

    // Filter out objects from audiencePayload where id is in falseIds array
    const filteredAudienceList = audiencePayload.filter(dataTag => !falseIds.includes(dataTag.id));

    // Set the filtered audience payload
    setAudiencePayload(filteredAudienceList);
  }, [selectedAudienceState]);

  const renderAudienceColumns = () => {
    const mappingKeys = {
      3: meta,
      4: adwords,
      5: dv360,
      7: tiktok,
      8: viads,
      // 'ion': IONLogo,
      // 'viads': ViLogo,
    };

    const titleKeys = {
      'ads': 'Google Ad',
      'meta': 'Meta',
      'tiktok': 'TikTok',
      'ion': 'ION',
      'viads': 'ViAds',
      'dv360': 'DV360'
    };

    const audienceTypeKeys = {
      0: 'Inmarket',
      1: 'Affinity',
      2: 'IAB',
      3: 'Geo',
      4: 'Demographic',
      5: 'Affinity',
      6: 'Behaviour',
      7: 'Interest',
      8: 'Interest',
      9: 'Behaviour',
      10: 'Demographic',
      11: 'Demographic',
      12: 'Demographic',
      13: 'Demographic',
      14: 'Demographic',
      15: 'Demographic',
      16: 'Demographic',
      17: 'Demographic',
      18: 'Demographic',
      19: 'Demographic',
      20: 'Demographic',
      21: 'VIL Digital',
      22: 'SMS'
    };
    //audienceTypeKeys provided by backend team

    // console.log("audData", audData)
    // console.log("listAudienceData", listAudienceData)
    // console.log("responseBySearchTerm", responseBySearchTerm)
    if (audData.length > 0 && selectedTab) {
      return (
        <>
          <Tabs activeKey={selectedTab} onChange={(key) => setSelectedTab(key)} tabBarStyle={{ borderBottom: 'none', position: 'relative' }}>
            {audData.map((tab) => (
              <TabPane tab={<span style={{ textTransform: 'capitalize' }}>{tab}</span>} key={tab}>
                {/* Render content for each tab */}
                {/* <div className='d-flex align-items-center search-adj audience-search-adj'>
                  <i style={{ color: "#A4ABB5", fontSize: 12, }} className='ti ti-search ti-sm'></i>
                  <Input
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.search.key]}
                    setting={formFields[formFields.search.key]}
                    error={errors[formFields.search.key]}
                    submited={submited}
                    // disabled={true}
                    touched={touched[formFields.search.key]} />
                </div> */}
                <div style={{
                  height: 350, overflowY: "scroll",
                }}>
                  {responseBySearchTerm[tab] && responseBySearchTerm[tab].length > 0 ? (
                    <table className="audience-table mt-0">
                      <thead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "white", boxShadow: "0px 0px 0px 2px #d2d2d26e" }}>
                        <th style={{
                          color: "#394256",
                          fontSize: 14,
                          lineHeight: "16.8px",
                          fontWeight: 500,
                          verticalAlign: "middle", // vertically center
                          maxWidth: 300, width: 300
                        }}
                          colspan="2"
                        >
                          <Checkbox
                            checked={selectedAudienceState[selectedTab] && selectedAudienceState[selectedTab].selectAll}
                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                            style={{
                              marginRight: 5,
                            }}
                          />
                          <div style={{ display: "inline-block" }}>Select All</div>
                          {/* <i className="ti ti-arrows-sort ti-xs ml-2 mt-n2" style={{ verticalAlign: "middle" }}></i> */}
                        </th>

                        {/* <th style={{ color: "#394256", fontSize: 14, lineHeight: "16.8px", fontWeight: 500, maxWidth: 200, width: 200 }} colspan="2">
                          <i className="ti ti-arrows-sort ti-xs"></i>
                        </th> */}

                        <th style={{ color: "#394256", fontSize: 14, lineHeight: "16.8px", fontWeight: 500 }} colspan="1">
                          {/* <i className="ti ti-arrows-sort ti-xs"></i> */}
                        </th>

                        <th style={{ color: "#394256", fontSize: 14, lineHeight: "16.8px", fontWeight: 500 }} colspan="1">
                          {/* <i className="ti ti-arrows-sort ti-xs"></i> */}
                        </th>
                      </thead>
                      <tbody>
                        {/* {listAudienceData.map((option) => ( */}
                        {responseBySearchTerm[selectedTab] && responseBySearchTerm[selectedTab].length > 0 && responseBySearchTerm[selectedTab].map((option) => (
                          <tr key={option.id} className="audience-data">
                            <td colspan="2" style={{ maxWidth: 300, width: 300 }}>

                              <Checkbox
                                checked={selectedAudienceState[selectedTab] && selectedAudienceState[selectedTab][option.id]}
                                onChange={(e) => handleCheckboxChange(option, e.target.checked)}
                              />{' '}&nbsp;

                              {option.name}
                              {/* <i className="ti ti-info-circle mt-n1" style={{ fontSize: 15 }} title={option.canonicalPath}></i> */}
                            </td>

                            {/* <td colspan="2" style={{ maxWidth: 200, width: 200 }}>
                              {option.canonicalPath}
                            </td> */}

                            <td colspan="1">
                              {/* <Checkbox
                              checked={selectedAudienceState[selectedTab] && selectedAudienceState[selectedTab][option.id]}
                              onChange={(e) => handleCheckboxChange(option.id, e.target.checked)}
                            />{' '}&nbsp; */}
                              <i className="ti ti-info-circle mt-0" style={{ fontSize: 15 }} title={option.canonicalPath}></i>  {audienceTypeKeys[option.type]}

                              {/* Render data for Google AdWords */}
                            </td>
                            <td colspan="1">
                              <img src={mappingKeys[option.platformId]} alt={mappingKeys[option.platformId]} style={{ height: 26, width: 27, objectFit: "contain" }} />
                              {/* <div className='checkbox-title'>{titleKey}</div> */}
                            </td>

                            {/* Add more columns as needed */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center pb-4">
                      <h4>No Audience Available</h4>
                    </div>
                  )}
                </div>
              </TabPane>
            ))}
          </Tabs>
        </>
      );

    }
    return null;
  };

  const locationApiFunction = async (searchTerm) => {
    if (searchTerm.trim() == "") {
      // If searchTerm is empty or contains only whitespaces, do not make the API call
      return;
    }


    const mappingKeys = {
      'ads': 4,
      'meta': 3,
      'tiktok': 7,
      'ion': 2,
      'ioh': 2,
      'viads': 2, // only for Location viads, ioh, ion are 2 for other apis it is different
      'dv360': 4
    };

    const channel = platformKeys.map(platform => mappingKeys[platform]);
    const uniqueChannels = [...new Set(channel)]; // Remove duplicates
    uniqueChannels.sort((a, b) => a - b); // Sort in ascending order


    const params = {
      recoplan: "location",
      name: searchTerm,
      channel: uniqueChannels.join(',') // Set the channel based on platformKeys without duplicates
    };

    // curl 'http://localhost:7018/beki/targeting?recoplan=location&name=india&channel=2,3,5' 

    await dispatch(getAudienceAction({ tenantId, authToken, userId, params }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          responseObj,
        } = data;

        // console.log("responseObj", responseObj)

        if (status === "Success") {
          const mappedOptions = responseObj.map((location) => ({
            ...location,
            value: location.id,
            label: location.name,
          }));
          // console.log("mappedoptions", mappedOptions)

          setLocationData(mappedOptions);
        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const audienceApiFunction = async (searchTerm) => {
    // curl 'http://localhost:7018/beki/targeting?recoplan=audience&name=travel&channel=4,5' 

    // console.log("searchTerm", searchTerm)
    if (searchTerm.trim() == "") {
      // If searchTerm is empty or contains only whitespaces, do not make the API call
      return;
    }

    const mappingKeys = {
      'ion': 2,
      'meta': 3,
      'ads': 4,
      'dv360': 5,
      'tiktok': 7,
      'viads': 8,
    };

    const channel = platformKeys.map(platform => mappingKeys[platform]);
    const uniqueChannels = [...new Set(channel)]; // Remove duplicates
    uniqueChannels.sort((a, b) => a - b); // Sort in ascending order


    const params = {
      recoplan: "audience",
      name: searchTerm,
      channel: uniqueChannels.join(',') // Set the channel based on platformKeys without duplicates
    };

    await dispatch(getAudienceAction({ tenantId, authToken, userId, params }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          responseObj,
        } = data;


        if (status === "Success") {
          // const mappedOptions = response.map((location) => ({
          //   value: location.id,
          //   label: location.name,
          // }));
          // console.log("response894", responseObj)

          setListAudience(responseObj);
          setResponseBySearchTerm((prevResponse) => ({
            ...prevResponse,
            [searchTerm]: responseObj,
          }));
        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };


  const handleKeyDown = async (e) => {
    const { key } = e;
    const { name, value } = e.target;
    if (name == formFields.audience.key) {
      if (key.toLowerCase() == "enter" && value.trim().length > 0) {
        if (!audData.includes(value)) {
          let dataAudienceCloned = cloneDeep(audData);
          dataAudienceCloned.push(value);
          audienceApiFunction(value)
          setaudData([value]);
          // setaudData(dataAudienceCloned);
          setForm((prevForm) => ({ ...prevForm, [name]: '' }));
          setSelectedTab(value); // Set the selected tab to the newly added tag

        } else {
          // Value is already present, handle accordingly (e.g., show a message)
          message.error(`${value.toUpperCase()} already exists`);
        }

      }
    }
    else if (name == formFields.keywords.key) {
      if (key.toLowerCase() == "enter" && value.trim().length > 0) {
        let dataKeywordsCloned = cloneDeep(keywordsData);
        dataKeywordsCloned.push(value);
        setKeywordsData(dataKeywordsCloned);
        setForm((prevForm) => ({ ...prevForm, [name]: "" }));
      }
    }
    else if (name == formFields.sites.key) {
      if (key.toLowerCase() == "enter" && value.trim().length > 0) {
        let dataSitesCloned = cloneDeep(sitesData);
        dataSitesCloned.push(value);
        setSitesData(dataSitesCloned);
        setForm((prevForm) => ({ ...prevForm, [name]: "" }));
      }
    }
  };

  const removeTag = (tag) => {
    // console.log("1234 tag", tag)
    // Remove the tag from audData
    let filteredTagList = audiencePayload.filter((dataTag) => dataTag.id !== tag.id);
    setAudiencePayload(filteredTagList);

    let filteredTagListForm = form.audiencePayload.filter((dataTag) => dataTag.id !== tag.id);
    setForm((prevForm) => {
      return {
        ...prevForm,
        audiencePayload: filteredTagListForm
      }
    })
    // console.log("1234 filteredTagList", filteredTagList)
    // console.log("1234 filteredTagListForm", filteredTagListForm)

    // Remove corresponding data from responseBySearchTerm
    let updatedResponseBySearchTerm = { ...responseBySearchTerm };
    delete updatedResponseBySearchTerm[tag];
    setResponseBySearchTerm(updatedResponseBySearchTerm);

    // Remove entries associated with the removed tag from selectedAudienceState
    const newSelectedAudienceState = { ...selectedAudienceState };

    Object.keys(newSelectedAudienceState).forEach((tab) => {
      // console.log("1234 tab", tab)
      // console.log("1234 tag", tag)
      // if (tab === tag) {
      //   // Remove the tag (e.g., "art") from newSelectedAudienceState
      //   delete newSelectedAudienceState[tab];
      // } else {
      // Remove the tag from individual checkboxes
      if (newSelectedAudienceState[tab]) {
        delete newSelectedAudienceState[tab][tag.id];

        // Check if 'selectAll' should be updated
        const selectedTabAudience = responseBySearchTerm[tab] || [];
        const allChecked = selectedTabAudience.every((option) => newSelectedAudienceState[tab] && newSelectedAudienceState[tab][option.id]);

        // Update the 'selectAll' checkbox state
        newSelectedAudienceState[tab] = {
          ...newSelectedAudienceState[tab],
          selectAll: allChecked,
        };
      }
      // }
    });

    // console.log("1234 newSelectedAudienceState", newSelectedAudienceState)

    setSelectedAudienceState(newSelectedAudienceState);
  };


  const removeKeywordsTag = (tag) => {
    let filtedTagList = keywordsData.filter((dataTag) => dataTag != tag);
    setKeywordsData(filtedTagList);
  };


  const removeSitesTag = (tag) => {
    let filtedTagList = sitesData.filter((dataTag) => dataTag != tag);
    setSitesData(filtedTagList);
  };

  const renderNestedList = (list) => {
    if (!list || list.length === 0) {
      return null;
    }

    return (
      <div className="d-flex flex-column pl-5">
        {list.map((item) => (
          <div className='checkbox-group' key={item.id}>
            <div className='checkbox-item'>
              <input type="checkbox" id={`fb${item.name.replace(/\s+/g, '')}`} name={`fb${item.name.replace(/\s+/g, '')}`} />
              <label htmlFor={`fb${item.name.replace(/\s+/g, '')}`}>{item.name}</label>
            </div>
            {renderNestedList(item.list)}
          </div>
        ))}
      </div>
    );
  };


  useEffect(() => {
    // console.log("next", strategyNext)
    if (strategyNext)
      tableFinalPayload();
  }, [strategyNext])


  const tableFinalPayload = async () => {

    try {

      let initialPayload = {};


      if (strategyData) {
        // console.log("strategyData", strategyData)
        Object.keys(strategyData).forEach((platform, index) => {
          let strategyName = `${platform}Strategy`;
          let strategyType = `strategyType`;
          let defaultList = `defaultList`;
          initialPayload[strategyName] = {};
          initialPayload[strategyType] = { ...initialPayload[strategyType] };
          initialPayload[defaultList] = [];
          strategyData[platform].forEach((item, i) => {
            let id = item.id.toString();
            // console.log("item----", item)

            // Map the stratgies array and update startDate and endDate to sDate and eDate
            item.stratgies = item.stratgies.map((strat) => {
              if (!strat.hasOwnProperty('sDate') || !strat.hasOwnProperty('eDate')) {
                return {
                  ...strat,
                  sDate: strat.startDate,
                  eDate: strat.endDate,
                };
              } else {
                return strat;
              }
            });
            initialPayload[strategyName][id] = item.stratgies.map(strat => strat.id);

            // Checking if type is not -1 then send the type from outter object
            if (item.type != -1) {
              initialPayload[strategyType][item.stratgies.map(strat => strat.id)] = item.type;
            } else {
              // Checking if type is -1 then send the inner type from stratgies[]
              item.stratgies.forEach((strat) => {
                initialPayload[strategyType][strat.id] = strat.type;
              });
            }

            // console.log(initialPayload, 'RESULT UUU');
            // console.log("initialPayload", initialPayload);
            // console.log("id----", id)
            initialPayload[defaultList] = strategyData[platform].map(val => val.stratgies); // stratgies spelling wrong at backend
            initialPayload[defaultList] = initialPayload[defaultList].flat();
            // initialPayload[platform] = initialPayload[platform].map(data => ({ ...data }));
          });
        });
        // console.log("initialPayload", initialPayload);
        // setResultPayload(initialPayload)
        // tableFinalPayloadForm()

      }


      // console.log("initialPayload", initialPayload);

      const updatedDefaultList = { ...initialPayload.defaultList[0] };
      const { bidcap, biddingStrategy, pacing, duration } = form;
      // debugger;
      // initialPayload.defaultList.push()
      initialPayload.defaultList[0].bidCap = bidcap;
      initialPayload.defaultList[0].bidStrategy = biddingStrategy;
      initialPayload.defaultList[0].pacingType = pacing;
      initialPayload.defaultList[0].duration = duration;
      initialPayload.defaultList[0].status = 1; // Recommended status
      initialPayload.defaultList[0].isReco = 1; // Recommended isReco
      initialPayload.defaultList[0].isRecActive = 3; // Recommended isRecActive
      // console.log("initialPayload form", form);

      //-----DEVICE-------
      const devicePayload = selectedDevices.map((item) => ({
        key: item.id,
        value: item.value,
      }));

      if (devicePayload.length > 0) {
        initialPayload.defaultList[0].targeting.device = devicePayload;
        // console.log("initialPayload", initialPayload);
      }

      //-----AGE-------
      let matchingAgeObj = {}
      matchingAgeObj = ageRangeData.find(item => item.value == `${form.ageFrom + '-' + form.ageTo}`);
      // console.log("matchingAgeObj", matchingAgeObj)

      if (matchingAgeObj && matchingAgeObj.hasOwnProperty("id")) {
        initialPayload.defaultList[0].targeting.age = parseInt(matchingAgeObj.id)
      }

      //-----GENDER-------
      const genderPayload = selectedGenders.map((item) => ({
        key: item.id,
        value: item.value,
      }));

      if (genderPayload.length > 0) {
        initialPayload.defaultList[0].targeting.gender = genderPayload;
      }

      //-----LANGUAGE-------
      const languagePayload = selectedLanguages.map((item) => ({
        beki: item.id,
        value: item.value,
        inex: 1
      }));

      if (languagePayload.length > 0) {
        initialPayload.defaultList[0].targeting.languages = languagePayload;
      }

      // console.log("initialPayload", initialPayload);


      //----FREQUENCY CAP------
      if (selectedOptionFrequency === "limited" && form.frequencyCapTo) {
        initialPayload.defaultList[0].freqCap = { ...initialPayload.defaultList[0].freqCap };
        initialPayload.defaultList[0].freqCap['cap'] = parseInt(form.frequencyCapTo)
        initialPayload.defaultList[0].freqCap['interval'] = parseInt(form.frequencyCapPerInterval)
        // updatedDefaultList.freqCap.level = 1
      }
      // initialPayload.defaultList[0] = {
      //   ...(selectedOptionFrequency == "limited" ? {
      //     "freqCap": {
      //       "cap": parseInt(form.frequencyCapTo),
      //       // "time": parseInt(form.frequencyCapTime),
      //       "interval": parseInt(form.frequencyCapPerInterval),
      //       // "level": 1
      //     }
      //   } : {}),
      // }

      // //----PAGE META------
      // if (form.fbPageList) {
      //   // initialPayload.defaultList[0].targeting.pageId = form.fbPageList;
      //   initialPayload.defaultList[0].accountId = form.fbPageAccount;
      //   initialPayload.defaultList[0].targeting.page = [{
      //     // accountId: form.fbPageAccount,
      //     key: form.fbPageList,
      //     value: form.fbPageList
      //   }]
      // }

      //----PAGE META------
      if (form.fbPageList && form.fbPageAccount) {
        initialPayload.defaultList[0].accountId = form.fbPageAccount;

        // console.log("111 fbPageData", fbPageData);
        // console.log("111 form.fbPageList", form.fbPageList);

        const filteredPages = fbPageData.filter(page => {
          // console.log("Comparing form.fbPageList:", form.fbPageList, "with page.id:", page.id);
          return form.fbPageList == page.id; // Make sure to compare as strings
        });

        // console.log("111 filteredPages", filteredPages);

        if (filteredPages.length > 0) {
          initialPayload.defaultList[0].targeting.page = filteredPages.map(page => ({
            key: page.id,
            value: page.name
          }));

          // console.log("111 initialPayload", initialPayload);
        }
      }



      // console.log("111 initialPayload", initialPayload)


      //----DAY PART-----
      const formattedDayparts = dayparts.map((daypart) => {
        const selectedDays = daypart.selectedDays
          .map((day) => dayOfWeekMap[day])
          .join(',');

        const time = `${daypart.startTime.toString().replace(":", '.')},${daypart.endTime.toString().replace(":", '.')}`;

        return {
          day: selectedDays,
          time,
          startDate: daypart.startDate && moment(daypart.startDate).format('YYYY-MM-DD') ? getUserSelectedDateInUtc({
            date: daypart.startDate,
            targetTimeZone: targetTimeZone,
            isStartDate: true,
          }) : '',
          endDate: daypart.endDate && moment(daypart.endDate).format('YYYY-MM-DD') ? getUserSelectedDateInUtc({
            date: daypart.endDate,
            targetTimeZone: targetTimeZone,
            isStartDate: false,
          }) : '',
        };
      });
      if (selectedOption === "customSchedules" && formattedDayparts.length > 0) {
        initialPayload.defaultList[0].targeting.daypart = [...initialPayload.defaultList[0].targeting.daypart]
        initialPayload.defaultList[0].targeting.daypart = formattedDayparts
      }

      //---KEYWORDS-----
      if (keywordsData.length > 0) {
        initialPayload.defaultList[0].targeting.keywords = { ...initialPayload.defaultList[0].targeting.keywords };
        initialPayload.defaultList[0].targeting.keywords['values'] = keywordsData.map(keyword => (keyword))
        initialPayload.defaultList[0].targeting.keywords['index'] = 1
      }

      //----SITES----
      if (sitesData.length > 0) {
        initialPayload.defaultList[0].targeting.sites = { ...initialPayload.defaultList[0].targeting.sites };
        initialPayload.defaultList[0].targeting.sites['values'] = sitesData.map(site => (site))
        initialPayload.defaultList[0].targeting.sites['inex'] = selectedOptionSites == "whiteList" ? 1 : 0
      }

      //-----ON-SCREEN-POSITION-------
      if (onScreenData && onScreenData.length > 0) {
        // "position": onScreenData && onScreenData.length > 0 ? onScreenData.map(item => ({ key: item.id, value: item.name })) : []

        initialPayload.defaultList[0].targeting['position'] = onScreenData.map(item => ({ key: item.id, value: item.name, platformId: item.platformId }))
      }

      //----AUDIENCE----
      if (audiencePayload.length > 0) {
        initialPayload.defaultList[0].targeting['audience'] = audiencePayload
      }

      //----LOCATION----
      if (locationPayload.length > 0) {
        const uniqueAdsValues = new Set();
        // console.log("aaa-locationPayload", locationPayload)
        const uniqueLocationData = locationPayload.filter(item => {
          // Check if the ads value is already in the Set
          if (uniqueAdsValues.has(item['beki'])) {
            return false; // Skip duplicates
          }

          // Add the ads value to the Set and include the item in the new array
          uniqueAdsValues.add(item['beki']);
          return true;
        });

        // console.log("aaa-12345", uniqueLocationData);
        initialPayload.defaultList[0].targeting['location'] = uniqueLocationData
        // [{ "inex": 1, "beki": "55006", "value": "India", "type": "Country" }, { "inex": 0, "beki": "55033", "value": "Indonesia", "type": "Country" }, { "inex": 1, "beki": "55406", "value": "Haryana", "type": "State" }]
      }

      if (
        onScreenData.length > 0 && form.dataConfig
      ) {
        const { response = [] } = form.dataConfig;
        const uniquePlatforms = [
          ...new Set(
            onScreenData.map(
              (item) => item.publisherPlatform
            )
          ),
        ];

        const publisherPlatformList = response.find(
          (item) =>
            item.platformId == 3 &&
            item.name === configKeys.Publisher_Platforms
        );

        if (publisherPlatformList && publisherPlatformList.list) {
          const result = publisherPlatformList.list
            .filter((item) => uniquePlatforms.includes(item.name))
            .map((item) => ({ key: item.id, value: item.name }));
          initialPayload.defaultList[0].targeting['publisherPlatform'] = result;
        }
      }




      // setResultPayload({
      //   ...initialPayload,
      //   defaultList: [updatedDefaultList],
      // });
      let { errors, valid } = handleError(form, formFields);
      // console.log("valid", valid)
      // console.log("errors", errors)

      // debugger;
      if (!valid) {
        message.error('Please fill all required fields');
        setErrors(errors);
        setSubmited(true);
        return;
      }

      // if (!updatedDefaultList.bidStrategy || updatedDefaultList.bidStrategy == 0) {
      //   message.error('Please fill BidStrategy');
      //   setStrategyNext(0)
      //   return;

      // }
      // if (!updatedDefaultList.bidCap || updatedDefaultList.bidCap == 0) {
      //   message.error('Please fill BidCap');
      //   setStrategyNext(0)
      //   return;

      // }
      // if (!updatedDefaultList.pacingType) {
      //   message.error('Please fill Pacing');
      //   setStrategyNext(0)
      //   return;

      // }
      // if (!updatedDefaultList.duration) {
      //   message.error('Please fill Duration');
      //   setStrategyNext(0)
      //   return;

      // }

      if (strategyData.hasOwnProperty('meta') && strategyData.meta.length > 0 && !isDemoAdvertiser) {
        if (!initialPayload.defaultList[0].targeting.location.length > 0) {
          message.error('Please fill Location');
          setStrategyNext(0)
          return;

        }
        if (!initialPayload.defaultList[0].targeting.page) {
          message.error('Please fill Page');
          setStrategyNext(0)
          return;

        }
      }



      if (isDemoAdvertiser) {
        // needs add check first whether or not we are editing the dynamic campaign
        if (props.location.pathname.includes("edit-campaign") || props.location.pathname.includes("view-campaign")) {
          const { match: { params: { id } } } = props;
          if (isDemoCampaign(campaignList, id)) {
            // console.log("available")
            const {
              responseCode: { status = "", msg },
              responseObj = {},
            } = recoCampaignCreativeData;

            dispatch(strategyCreativeDataAction({ data: responseObj }))
            message.success(msg)
            next();
            return;
          }
        }
      }

      // debugger;
      await dispatch(postFinalStrategyAction({ tenantId, authToken, userId, payload: initialPayload })).then((data) => {
        const {
          responseCode: { status = "", msg },
          responseObj = {},
        } = data;

        if (status === "Success") {
          dispatch(strategyCreativeDataAction({ data: responseObj }))
          message.success(msg)
          next();
        }
        else if (status == "Fail") {
          setStrategyNext(0)
          message.error(msg)
        }
        else {
          console.log("Data not found");
        }
      })
        .catch((error) => {
          setStrategyNext(0)
          console.error(error);
        });
    }
    catch (err) {
      setStrategyNext(0)
    }
  }

  useEffect(() => {
    const getDayPartData = async () => {
      const { tenantId, authToken, userId, getCampaignAction } = props;
      const params = {
        daypart: "list",
        platformId: 3,
      };

      if (isDemoAdvertiser) {
        const { match: { params: { id } } } = props;
        if (isDemoCampaign(campaignList, id)) {
          if (props.location.pathname.includes("edit-campaign") || props.location.pathname.includes("view-campaign")) {
            const {
              responseCode: { msg = "", status = "" },
              responseObj = {},
            } = recoCampaignDaypartList

            const hourData = {
              startTime: [],
              endTime: [],
            };
            const { sHour = "[]", eHour = "[]" } = responseObj;
            hourData.startTime = sHour
              .replace("[", "")
              .replace("]", "")
              .trim()
              .split(",");
            hourData.endTime = eHour
              .replace("[", "")
              .replace("]", "")
              .trim()
              .split(",");
            if (
              Array.isArray(hourData.startTime) &&
              Array.isArray(hourData.endTime)
            ) {
              hourData.startTime = hourData.startTime.map((data) => ({
                key: data.replace(" ", ""),
                text: data.toString().replace(".", ":").replace(" ", ""),
              }));
              hourData.endTime = hourData.endTime.map((data) => ({
                key: data.replace(" ", ""),
                text: data.toString().replace(".", ":").replace(" ", ""),
              }));
            }

            setOptionsData((prevOptions) => {
              return {
                ...prevOptions,
                endTimeOptions: hourData.endTime,
                startTimeOptions: hourData.startTime,
              };
            });

            return;
          }
        }
      }

      const {
        responseCode: { msg = "", status = "" },
        responseObj = {},
      } = await getCampaignAction({ tenantId, authToken, userId, params });

      if (isApiCallSuccess(status)) {
        const hourData = {
          startTime: [],
          endTime: [],
        };
        const { sHour = "[]", eHour = "[]" } = responseObj;
        hourData.startTime = sHour
          .replace("[", "")
          .replace("]", "")
          .trim()
          .split(",");
        hourData.endTime = eHour
          .replace("[", "")
          .replace("]", "")
          .trim()
          .split(",");
        if (
          Array.isArray(hourData.startTime) &&
          Array.isArray(hourData.endTime)
        ) {
          hourData.startTime = hourData.startTime.map((data) => ({
            key: data.replace(" ", ""),
            text: data.toString().replace(".", ":").replace(" ", ""),
          }));
          hourData.endTime = hourData.endTime.map((data) => ({
            key: data.replace(" ", ""),
            text: data.toString().replace(".", ":").replace(" ", ""),
          }));
        }


        setOptionsData((prevOptions) => {
          return {
            ...prevOptions,
            endTimeOptions: hourData.endTime,
            startTimeOptions: hourData.startTime,
          };
        });
      }
    }
    getDayPartData();
  }, []);

  const defaultCampaignMinDate = moment(getCurrentDateInTimeZone(targetTimeZone)).toDate();
  const campaignMaxDate = moment(getDateFromUtcToSpecificZone({ date: basicDetailsForm.endDate ? basicDetailsForm.endDate : "", targetTimeZone })).toDate();

  const openInformationModal = (text = "") => {
    dispatch(reduxDrawerAction({ showDragger: true, data: text }));
  };

  const infoButtonBooleanData = useMemo(() => {
    let infoObj = {};
    if (Object.keys(strategyInfoData).length > 0) {
      Object.keys(strategyInfoData).map((data) => {
        if (strategyInfoData[data] && strategyInfoData[data].length > 0) {
          infoObj[data] = true;
        }
      });
    }

    return infoObj;
  }, [strategyInfoData]);


  let isFeedsForMetaChecked = false;
  let isStoriesReelsForMetaChecked = false;
  let isSearchResultForMetaChecked = false;
  let isAppSitesForMetaChecked = false;
  let isMessagesForMetaChecked = false;
  let isInstreamForMetaChecked = false;

  if (platformKeys.includes("meta")) {
    const {
      metaManualPositionOptions: {
        feeds: { list: feedsList },
        stories: { list: storiesList },
        search: { list: searchList },
        appSites: { list: appSiteList },
        messages: { list: messagesList },
        instreamAds: { list: instreamList },
      }
    } = onScreenPositionDetails;

    const checkIfExists = (list) => onScreenData.some(secondItem => list.some(firstItem => firstItem.id === secondItem.id));

    isFeedsForMetaChecked = checkIfExists(feedsList);
    isStoriesReelsForMetaChecked = checkIfExists(storiesList);
    isSearchResultForMetaChecked = checkIfExists(searchList);
    isAppSitesForMetaChecked = checkIfExists(appSiteList);
    isMessagesForMetaChecked = checkIfExists(messagesList);
    isInstreamForMetaChecked = checkIfExists(instreamList);
  }

  // console.log(onScreenData,'&&&&')

  return (
    <>
      <div className={`row ${isViewCampaign ? 'pe-none' : 'pe-auto'}`}>
        <div className="col-md-6">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.biddingStrategy.key]}
            setting={formFields[formFields.biddingStrategy.key]}
            error={errors[formFields.biddingStrategy.key]}
            submited={submited}
            touched={touched[formFields.biddingStrategy.key]}
            options={biddingStrategy}
            infoIcon={infoButtonBooleanData[infoKeys.biddingStrategy]}
            onInfoClick={() => {
              openInformationModal(strategyInfoData[infoKeys.biddingStrategy]);
            }}
          />
        </div>
        <div className="col-md-6 ">
          <Input
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.bidcap.key]}
            setting={formFields[formFields.bidcap.key]}
            error={errors[formFields.bidcap.key]}
            submited={submited}
            touched={touched[formFields.bidcap.key]}
            infoIcon={infoButtonBooleanData[infoKeys.bidCap]}
            onInfoClick={() => {
              openInformationModal(strategyInfoData[infoKeys.bidCap]);
            }}
          />
        </div>
        <div className="col-md-6 ">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.pacing.key]}
            setting={formFields[formFields.pacing.key]}
            error={errors[formFields.pacing.key]}
            submited={submited}
            touched={touched[formFields.pacing.key]}
            options={pacingData}
            disabled
            infoIcon={infoButtonBooleanData[infoKeys.pacingType]}
            onInfoClick={() => {
              openInformationModal(strategyInfoData[infoKeys.pacingType]);
            }}
          />
        </div>
        <div className="col-md-6">
          <SelectNew
            onChange={handleChange}
            onBlur={handleTouch}
            value={form[formFields.duration.key]}
            setting={formFields[formFields.duration.key]}
            error={errors[formFields.duration.key]}
            submited={submited}
            touched={touched[formFields.duration.key]}
            // options={durationData}
            options={durationData}
            disabled
            infoIcon={infoButtonBooleanData[infoKeys.durationType]}
            onInfoClick={() => {
              openInformationModal(strategyInfoData[infoKeys.durationType]);
            }}
          />
        </div>

        <div className="col-md-6">
          <div className="form-group row ">
            <label for="agegroup" class="col-12 col-form-label">
              Age Group <span class="small" style={{ color: "#1925238a" }}>Optional</span>
              <InfoButton
                infoIcon={infoButtonBooleanData[infoKeys.age]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.age]
                  );
                }}
              />
              {/* <span class="text-danger">*</span> */}
            </label>
            <div className="col-md-6">
              <SelectNew
                onChange={handleChange}
                onBlur={handleTouch}
                value={form[formFeildsAgeFromTo.ageFrom.key]}
                setting={formFeildsAgeFromTo[formFeildsAgeFromTo.ageFrom.key]}
                error={errors[formFeildsAgeFromTo.ageFrom.key]}
                submited={submited}
                touched={touched[formFeildsAgeFromTo.ageFrom.key]}
                options={ageFromOptions}
              />
            </div>
            <div className="col-md-6">
              <SelectNew
                onChange={handleChange}
                onBlur={handleTouch}
                value={form[formFeildsAgeFromTo.ageTo.key]}
                setting={formFeildsAgeFromTo[formFeildsAgeFromTo.ageTo.key]}
                error={errors[formFeildsAgeFromTo.ageTo.key]}
                submited={submited}
                touched={touched[formFeildsAgeFromTo.ageTo.key]}
                options={ageToOptions}
              />
            </div>
            <div className="col-12">
              <p className="small text-muted mt-n2">
                The selected age group will focus solely on platforms supporting age-based campaign targeting.
              </p>
            </div>
          </div>
        </div>


        <div className="col-md-6 ">

          <div className="form-group row mb-1 ">
            <label for="device" class="col-12 col-form-label pb-0">
              Gender  <span class="small" style={{ color: "#1925238a" }}>Optional</span>
              <InfoButton
                infoIcon={infoButtonBooleanData[infoKeys.gender]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.gender]
                  );
                }}
              />
            </label>
          </div>
          <Select
            options={genderData}
            isMulti={true}
            placeholder="Select Gender"
            defaultValue={selectedGenders}
            value={selectedGenders}
            onChange={(selected) => handleSelectChange(selected, "gender")}
            className="campaignFilter my-2"
          />
          <div className="col-12 px-0">
            <p className="small text-muted mt-0">
              The selected gender will focus solely on platforms supporting gender-based campaign targeting.
            </p>
          </div>
        </div>


        <div className="col-md-6 ">
          <div className="form-group row mb-1 ">
            <label for="device" class="col-12 col-form-label pb-0">
              Device  <span class="small" style={{ color: "#1925238a" }}>Optional</span>
              <InfoButton
                infoIcon={infoButtonBooleanData[infoKeys.device]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.device]
                  );
                }}
              />
            </label>
          </div>
          <Select
            options={deviceData}
            isMulti={true}
            placeholder="Select Device"
            defaultValue={selectedDevices}
            value={selectedDevices}
            onChange={(selected) => handleSelectChange(selected, "device")}
            className="campaignFilter my-2"
          />
        </div>


        <div className="col-md-6 ">

          <div className="form-group row mb-1 ">
            <label for="device" class="col-12 col-form-label pb-0">
              Language  <span class="small" style={{ color: "#1925238a" }}>Optional</span>
              <InfoButton
                infoIcon={infoButtonBooleanData[infoKeys.language]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.language]
                  );
                }}
              />
            </label>
          </div>
          <Select
            options={languageData}
            isMulti={true}
            placeholder="Select Language"
            defaultValue={selectedLanguages}
            value={selectedLanguages}
            onChange={(selected) => handleSelectChange(selected, "language")}
            className="campaignFilter my-2"
          />
        </div>



        <div className="col-md-6">
          <div class="form-group row col-md-12 px-0 pt-1" >
            <label class=" col-md-12 mt-2" >Frequency Management
              <InfoButton
                infoIcon={infoButtonBooleanData[infoKeys.frequencyCapping]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.frequencyCapping]
                  );
                }}
              />
            </label>

          </div>

          <div className="row align-items-start px-0">
            <div className="row mx-0 col-12 d-flex align-items-start mt-n3">
              <div className="col-12 px-0 d-flex justify-content-between">
                <div className="d-flex">
                  <input
                    type="radio"
                    id="none"
                    name="Frequency"
                    value="none"
                    checked={selectedOptionFrequency === "none"}
                    onChange={() => setSelectedOptionFrequency("none")}
                    style={{ marginTop: 10 }}
                  />
                  <label htmlFor="none" className="mb-0 pl-2 pr-4 pt-2 align-self-center">
                    None
                  </label>
                </div>

              </div>

              <div className="col-2 px-0 d-flex justify-content-between">
                <div className="d-flex">
                  <input
                    type="radio"
                    id="limited"
                    name="Frequency"
                    value="limited"
                    checked={selectedOptionFrequency === "limited"}
                    onChange={() => setSelectedOptionFrequency("limited")}
                    style={{ marginTop: 10 }}
                  />
                  <label htmlFor="limited" className="mb-0 pl-2 pt-2 align-self-center">
                    Limit Frequency
                  </label>
                </div>
              </div>

              <div className='col-5 d-flex justify-content-start align-items-start pr-0' >
                <div class="col-md-2 px-0 pl-1" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "13px" }}>To</label></div>
                <div class="col-md-10">
                  <Input
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.frequencyCapTo.key]}
                    setting={formFields[formFields.frequencyCapTo.key]}
                    error={errors[formFields.frequencyCapTo.key]}
                    submited={submited}
                    touched={touched[formFields.frequencyCapTo.key]}
                  />
                </div>
              </div>


              <div className='col-5 d-flex justify-content-start align-items-start pr-0' >
                <div class="col-md-2 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                <div class="col-md-10">

                  <SelectNew
                    disabled
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.frequencyCapPerInterval.key]}
                    setting={formFields[formFields.frequencyCapPerInterval.key]}
                    error={errors[formFields.frequencyCapPerInterval.key]}
                    submited={submited}
                    touched={touched[formFields.frequencyCapPerInterval.key]}
                    options={[{ id: 1, name: 'Day' }]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${isViewCampaign ? 'pe-none' : 'pe-auto'}`}>
        <CSSTransition
          in={showLocationForm}
          timeout={300}
          classNames="form-transition"
          unmountOnExit
        >
          <LocationSelect
            label="Add Location"
            selectedOptions={selectedLocation}
            onChange={(options) => handleSelectChange(options, "location")}
            onRemove={(removedOption) =>
              handleRemoveOption(removedOption, "location")
            }
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            options={locationData}
            placeholderMessage="Search & add location "
            locationApiFunction={locationApiFunction}
            platformType={props.platformType}
            rowData={props.rowData}
            setLocationPayload={setLocationPayload}
            locationPayload={locationPayload}
            infoButtonBooleanData={infoButtonBooleanData}
            openInformationModal={openInformationModal}
            infoData={strategyInfoData}

          />
        </CSSTransition>

        <CSSTransition
          in={showAudienceForm}
          timeout={300}
          classNames="form-transition"
          unmountOnExit
        >
          <div className="col-md-12 audience-set">
            <div className="form-group mb-0 ">
              <label for="agegroup" class="col-12 col-form-label mx-n4">
                Add Audience
                <InfoButton
                  infoIcon={infoButtonBooleanData[infoKeys.audience]}
                  onInfoClick={() => {
                    openInformationModal(
                      strategyInfoData[infoKeys.audience]
                    );
                  }}
                />
              </label>
            </div>
            <Input
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={(e) => {
                handleTouch(e);
              }}
              onKeyDown={(e) => {
                handleKeyDown(e);
              }}
              value={form[formFields.audience.key]}
              setting={formFields[formFields.audience.key]}
              error={errors[formFields.audience.key]}
              submited={submited}
              touched={touched[formFields.audience.key]}
            />
            <div className="d-flex flex-wrap mx-n2" style={{
              height: audiencePayload.length > 14 ? 120 : 'auto',
              overflowY: "scroll",
              border: audiencePayload.length > 0 ? "1px solid #ddd" : "unset",
              borderRadius: 10,
              background: "#f5f6ff"
            }}>
              {
                audiencePayload && audiencePayload.length > 0 ? audiencePayload.map((dataTag) => {
                  // console.log("dataTag", dataTag)
                  const mappingKeys = {
                    'ads': adwords,
                    'meta': meta,
                    'tiktok': tiktok,
                    'dv360': dv360,
                    'viads': viads,
                  };
                  return (
                    <div className="tagsTab d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                      {Object.keys(dataTag).map((key) => {
                        // console.log("dataTag-key", key)
                        if (key == "ads" || key == "dv360" || key == "meta" || key == "viads") {
                          return (
                            <div className="img-bg bg-white d-flex align-items-center mr-1" style={{ height: 24, width: 24, borderRadius: "50%" }}>
                              <img src={mappingKeys[key]} alt={key} style={{ height: key == "meta" ? 12 : 16, width: 24, objectFit: "contain" }} />
                            </div>
                          )
                        }
                        return null;
                      })}
                      {dataTag.value}
                      <i
                        className="ti ti-x ml-1"
                        onClick={() => removeTag(dataTag)}
                        style={{ fontSize: 15, cursor: "pointer" }}
                      ></i>
                    </div>
                  );
                })
                  :
                  form.audiencePayload && form.audiencePayload.map((dataTag) => {
                    // console.log("dataTag", dataTag)
                    const mappingKeys = {
                      'ads': adwords,
                      'meta': meta,
                      'tiktok': tiktok,
                      'dv360': dv360
                    };
                    return (
                      <div className="tagsTab d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                        {Object.keys(dataTag).map((key) => {
                          // console.log("dataTag-key", key)
                          if (key == "ads" || key == "dv360" || key == "meta") {
                            return (
                              <div className="img-bg bg-white d-flex align-items-center mr-1" style={{ height: 24, width: 24, borderRadius: "50%" }}>
                                <img src={mappingKeys[key]} alt={key} style={{ height: key == "meta" ? 12 : 16, width: 24, objectFit: "contain" }} />
                              </div>
                            )
                          }
                          return null;
                        })}
                        {dataTag.value}
                        <i
                          className="ti ti-x ml-1"
                          onClick={() => removeTag(dataTag)}
                          style={{ fontSize: 15, cursor: "pointer" }}
                        ></i>
                      </div>
                    );
                  })
              }



            </div>
            {renderAudienceColumns()}

          </div>
        </CSSTransition>

        <CSSTransition
          in={showKeywordsForm}
          timeout={300}
          classNames="form-transition"
          unmountOnExit
        >
          <div className="col-md-12 mt-2">
            <div className="form-group row mb-0 ">
              <label for="agegroup" class="col-12 col-form-label px-0">
                Search Keywords
                <InfoButton
                  infoIcon={infoButtonBooleanData[infoKeys.keyword]}
                  onInfoClick={() => {
                    openInformationModal(
                      strategyInfoData[infoKeys.keyword]
                    );
                  }}
                />
              </label>
            </div>
            <Input
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={(e) => {
                handleTouch(e);
              }}
              onKeyDown={(e) => {
                handleKeyDown(e);
              }}
              value={form[formFields.keywords.key]}
              setting={formFields[formFields.keywords.key]}
              error={errors[formFields.keywords.key]}
              submited={submited}
              touched={touched[formFields.keywords.key]}
            />
            <div className="d-flex flex-wrap mx-n3">
              {keywordsData.map((dataTag) => {
                return (
                  <div className="tagsTab">
                    {dataTag}{" "}
                    <i
                      className="ti ti-x"
                      onClick={() => removeKeywordsTag(dataTag)}
                      style={{ fontSize: 15, cursor: "pointer" }}
                    ></i>
                  </div>
                );
              })}
            </div>
          </div>
        </CSSTransition>

        <CSSTransition
          in={showSitesForm}
          timeout={300}
          classNames="form-transition"
          unmountOnExit
        >
          <div className="row">
            <div className="col-md-6 mt-2 px-4">
              <div className="form-group row mb-0 ">
                <label for="agegroup" class="col-12 col-form-label px-0">
                  Search Sites
                  <InfoButton
                    infoIcon={infoButtonBooleanData[infoKeys.sites]}
                    onInfoClick={() => {
                      openInformationModal(
                        strategyInfoData[infoKeys.sites]
                      );
                    }}
                  />
                </label>
              </div>
              <Input
                onChange={(e) => {
                  handleChange(e);
                }}
                onBlur={(e) => {
                  handleTouch(e);
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                }}
                value={form[formFields.sites.key]}
                setting={formFields[formFields.sites.key]}
                error={errors[formFields.sites.key]}
                submited={submited}
                touched={touched[formFields.sites.key]}
              />
              <div className="col d-flex align-items-center mx-n3 pb-3">
                <div className="d-flex align-items-center pr-4">
                  <input
                    type="radio"
                    id="whiteList"
                    name="sites"
                    value="whiteList"
                    checked={selectedOptionSites == "whiteList"}
                    onChange={() => {
                      setSelectedOptionSites("whiteList");
                      // console.log(selectedOptionSites);
                    }}
                  />
                  <label htmlFor="whiteList" className="mb-0 pl-2">
                    White list all the sites
                  </label>
                </div>
                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    id="blackList"
                    name="sites"
                    value="blackList"
                    checked={selectedOptionSites == "blackList"}
                    onChange={() => {
                      setSelectedOptionSites("blackList");
                      // console.log(selectedOptionSites);
                    }}
                  />
                  <label htmlFor="blackList" className="mb-0 pl-2">
                    Black list all the sites
                  </label>
                </div>
              </div>
              <div className="d-flex flex-wrap mx-n3">
                {sitesData.map((dataTag) => {
                  return (
                    <div className="tagsTab">
                      {dataTag}{" "}
                      <i
                        className="ti ti-x"
                        onClick={() => removeSitesTag(dataTag)}
                        style={{ fontSize: 15, cursor: "pointer" }}
                      ></i>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center pt-4">

            </div>
          </div>
        </CSSTransition>
      </div>

      <CSSTransition
        in={showOnScreenPositionForm}
        timeout={300}
        classNames="form-transition"
        unmountOnExit
      >
        <>
          {
            // ['ion', 'meta', 'dv360'].includes(props.platformType.toString()) &&
            <div class="accordion mt-3 accordion-bordered details-accordion mb-3" id="accordionStyle1">
              <div className="form-group row mb-2">
                <label for="agegroup" class="col-12 col-form-label">
                  Onscreen Position Details
                  <InfoButton
                    infoIcon={infoButtonBooleanData[infoKeys.onscreenPosition]}
                    onInfoClick={() => {
                      openInformationModal(
                        strategyInfoData[infoKeys.onscreenPosition]
                      );
                    }}
                  />
                </label>
              </div>

              {
                platformKeys.includes("meta") &&
                <div class="accordion-item card mb-0">
                  <h2 class="accordion-header">
                    <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-1" aria-expanded="false">
                      Facebook
                    </button>
                  </h2>

                  <div id="accordionStyle1-1" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div className={`accordion-body ${isViewCampaign ? 'pe-none' : 'pe-auto'}`}>
                      <div className='row'>
                        <div className="col-md-12 ">
                          <SelectNew
                            onChange={handleChange}
                            onBlur={handleTouch}
                            value={form[formFields.onScreenFb.key]}
                            setting={formFields[formFields.onScreenFb.key]}
                            error={errors[formFields.onScreenFb.key]}
                            submited={submited}
                            touched={touched[formFields.onScreenFb.key]}
                            options={onScreenPositionDetails.metaOnScreenPositionOptions}
                          />
                        </div>

                        {showFbOptions && (
                          <div>
                            <div className="d-flex mb-2">
                              {
                                onScreenPositionDetails.publisherPlatforms.map((data, index) => (
                                  <div key={index} className='checkbox-item mr-4'>
                                    <input type="checkbox" checked={onScreenData.some(onScData => onScData.publisherPlatform == data.name)} id={`${data.name}`} onChange={(e) => { handleChangeCheckBoxPlatform(e, data.name) }} name={`
                                        ${data.name}`} />
                                    <label style={{
                                      color: '#040B1B',
                                      fontSize: 14,
                                      fontWeight: 500
                                    }} className="ml-2" htmlFor={`${data.name}`}>{data.displayName}</label>
                                  </div>
                                ))
                              }
                            </div>
                            <div>
                            </div>
                            <div style={{ height: 170, overflow: "scroll", whiteSpace: 'nowrap' }} className='onScreenFb showScrollBar d-flex flex-row'>
                              <div className="d-flex flex-column">
                                <div className='checkbox-title mb-2'><span>{onScreenPositionDetails.metaManualPositionOptions.feeds.title}</span>
                                  <span><input className="ml-3" type="checkbox" style={{ verticalAlign: "middle" }} checked={isFeedsForMetaChecked} onChange={(e) => {
                                    handleChangeCheckBoxStories(e, onScreenPositionDetails.metaManualPositionOptions.feeds.list);
                                  }} id="feeds" name={`feeds`} />
                                  </span></div>
                                <div className='checkbox-group'>
                                  {
                                    onScreenPositionDetails.metaManualPositionOptions.feeds.list.map((item, index) => {
                                      return (
                                        <div key={index} className='checkbox-item'>
                                          <input type="checkbox" checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 3)} id={item.id} name={`${item.name}_${item.id}`} />
                                          <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>

                              <div className="d-flex flex-column pl-5">
                                <div className='checkbox-title mb-2'>
                                  <span>{onScreenPositionDetails.metaManualPositionOptions.stories.title}</span>
                                  <span><input className="ml-3" type="checkbox" style={{ verticalAlign: "middle" }} checked={isStoriesReelsForMetaChecked} onChange={(e) => {
                                    handleChangeCheckBoxStories(e, onScreenPositionDetails.metaManualPositionOptions.stories.list)
                                  }} id="feeds" name={`feeds`} />
                                  </span>
                                </div>
                                <div className='checkbox-group'>
                                  {
                                    onScreenPositionDetails.metaManualPositionOptions.stories.list.map((item, index) => {
                                      return (
                                        <div key={index} className='checkbox-item'>
                                          <input type="checkbox" checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} id={item.id} onChange={() => handleOnScreenPositions(item, 3)} name={`${item.name}_${item.id}`} />
                                          <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>

                              <div className="d-flex flex-column pl-5">
                                <div className='checkbox-title mb-2'>
                                  <span>{onScreenPositionDetails.metaManualPositionOptions.search.title}</span>
                                  <span><input className="ml-3" type="checkbox" style={{ verticalAlign: "middle" }} checked={isSearchResultForMetaChecked} onChange={(e) => {
                                    handleChangeCheckBoxStories(e, onScreenPositionDetails.metaManualPositionOptions.search.list);
                                  }} id="feeds" name={`feeds`} />
                                  </span>
                                </div>
                                <div className='checkbox-group'>
                                  {
                                    onScreenPositionDetails.metaManualPositionOptions.search.list.map((item, index) => {
                                      return (
                                        <div key={index} className='checkbox-item'>
                                          <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 3)} name={`${item.name}_${item.id}`} />
                                          <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>

                              <div className="d-flex flex-column pl-5">
                                <div className='checkbox-title mb-2'>
                                  <span>{onScreenPositionDetails.metaManualPositionOptions.appSites.title}</span>
                                  <span><input className="ml-3" type="checkbox" style={{ verticalAlign: "middle" }} checked={isAppSitesForMetaChecked} onChange={(e) => {
                                    handleChangeCheckBoxStories(e, onScreenPositionDetails.metaManualPositionOptions.appSites.list);
                                  }} id="appSites" name={`appSites`} />
                                  </span>
                                </div>
                                <div className='checkbox-group'>
                                  {
                                    onScreenPositionDetails.metaManualPositionOptions.appSites.list.map((item, index) => {
                                      return (
                                        <div key={index} className='checkbox-item'>
                                          <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 3)} name={`${item.name}_${item.id}`} />
                                          <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                              <div className="d-flex flex-column pl-5">
                                <div className='checkbox-title mb-2'>
                                  <span>{onScreenPositionDetails.metaManualPositionOptions.messages.title}</span>
                                  <span><input className="ml-3" type="checkbox" style={{ verticalAlign: "middle" }} checked={isMessagesForMetaChecked} onChange={(e) => {
                                    handleChangeCheckBoxStories(e, onScreenPositionDetails.metaManualPositionOptions.messages.list);
                                  }} id="messages" name={`messages`} />
                                  </span>
                                </div>
                                <div className='checkbox-group'>
                                  {
                                    onScreenPositionDetails.metaManualPositionOptions.messages.list.map((item, index) => {
                                      return (
                                        <div key={index} className='checkbox-item'>
                                          <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 3)} name={`${item.name}_${item.id}`} />
                                          <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                              <div className="d-flex flex-column pl-5">
                                <div className='checkbox-title mb-2 pr-2'>
                                  <span>{onScreenPositionDetails.metaManualPositionOptions.instreamAds.title}</span>
                                  <span><input className="ml-3" type="checkbox" style={{ verticalAlign: "middle" }} checked={isInstreamForMetaChecked} onChange={(e) => {
                                    handleChangeCheckBoxStories(e, onScreenPositionDetails.metaManualPositionOptions.instreamAds.list);
                                  }} id="instramAds" name={`instramAds`} />
                                  </span>
                                </div>
                                <div className='checkbox-group'>
                                  {
                                    onScreenPositionDetails.metaManualPositionOptions.instreamAds.list.map((item, index) => {
                                      return (
                                        <div key={index} className='checkbox-item'>
                                          <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 3)} name={`${item.name}_${item.id}`} />
                                          <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        )}


                      </div>
                    </div >
                  </div>
                </div>
              }

              {
                platformKeys.includes("dv360") && onScreenPositionDetails && onScreenPositionDetails.dv360PositionOptions &&
                // console.log("onScreenPositionDetails",onScreenPositionDetails) &&
                < div class="card accordion-item mb-0">
                  <h2 class="accordion-header">
                    <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="false">
                      DV360
                    </button>
                  </h2>
                  <div id="accordionStyle1-3" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div className={`accordion-body ${isViewCampaign ? 'pe-none' : 'pe-auto'}`}>
                      <div className="row onScreenDV">
                        <div className='checkbox-title my-2'>
                          Select position on screen
                        </div>
                        {
                          // creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('display') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.onScreen.display.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.onScreen.display.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 5)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }

                        {
                          // creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('video') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.onScreen.video.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.onScreen.video.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 5)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }


                        <div className='checkbox-title mb-2 mt-3'>
                          Select position in content
                        </div>
                        {
                          // creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('display') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.inContent.inDisplay.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.inContent.inDisplay.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 5)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }

                        {
                          // creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('video') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.inContent.videoInStream.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.inContent.videoInStream.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 5)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }

                        {
                          // creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('video') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.dv360PositionOptions.inContent.videoOutStream.title}</p>
                            {
                              onScreenPositionDetails.dv360PositionOptions.inContent.videoOutStream.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 5)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }

              {
                platformKeys.includes("viads") &&
                <div class="card accordion-item">
                  <h2 class="accordion-header">
                    <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-4" aria-expanded="false">
                      ViAds
                    </button>
                  </h2>
                  <div id="accordionStyle1-4" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div class="accordion-body pt-2">
                      <p>Position</p>
                      <div className="row onScreenDV">

                        {
                          // creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('display') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.viadsPositionOptions.display.title}</p>
                            {
                              onScreenPositionDetails.viadsPositionOptions.display.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 8)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }

                        {
                          // creativeMappingKeys[props.rowData.type] && creativeMappingKeys[props.rowData.type].includes('video') &&
                          <div className="col-md-3">
                            <p>{onScreenPositionDetails.viadsPositionOptions.video.title}</p>
                            {
                              onScreenPositionDetails.viadsPositionOptions.video.list.map((item, index) => {
                                return (
                                  <div key={index} className='checkbox-item'>
                                    <input type="checkbox" id={item.id} checked={onScreenData.some(screenPosition => screenPosition.id == item.id)} onChange={() => handleOnScreenPositions(item, 8)} name={`${item.name}_${item.id}`} />
                                    <label htmlFor={`${item.name}_${item.id}`}>{item.displayName ? item.displayName : item.name}</label>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }
                        {/* <Select
                                options={onScreenPositionDetails.ionViAdsOnScreenPositionOptions}
                                isMulti={true}
                                placeholder="Select Position"
                                defaultValue={ionViOnScreenData}
                                value={ionViOnScreenData}
                                onChange={(selected) => handleSelectChange(selected, "onScreenPosition")}
                                className="campaignFilter my-2"
                            /> */}
                      </div>
                    </div>
                  </div>
                </div>
              }

            </div >
          }
        </>
      </CSSTransition >
      <div className={`${isViewCampaign ? 'pe-none' : 'pe-auto'}`}>

        <CSSTransition
          in={showFlightForm}
          timeout={300}
          classNames="form-transition"
          unmountOnExit
        >
          <div className="form-group row">
            <label for="agegroup" class="col-12 col-form-label pb-3">
              Flight (Dayparting) <span class="text-danger">*</span>
              <InfoButton
                infoIcon={infoButtonBooleanData[infoKeys.flight]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.flight]
                  );
                }}
              />
            </label>
            <div className="col d-flex align-items-center">
              <div className="d-flex align-items-center pr-4">
                <input
                  type="radio"
                  id="allDatesAndDayParts"
                  name="flightSchedule"
                  value="allDatesAndDayParts"
                  checked={selectedOption === "allDatesAndDayParts"}
                  onChange={() => setSelectedOption("allDatesAndDayParts")}
                />
                <label htmlFor="allDatesAndDayParts" className="mb-0 pl-2">
                  Run on all Dates & Day Parts
                </label>
              </div>
              <div className="d-flex align-items-center">
                <input
                  type="radio"
                  id="customSchedules"
                  name="flightSchedule"
                  value="customSchedules"
                  checked={selectedOption === "customSchedules"}
                  onChange={() => setSelectedOption("customSchedules")}
                />
                <label htmlFor="customSchedules" className="mb-0 pl-2">
                  Add Custom Schedules
                </label>
              </div>
            </div>

            {selectedOption === "customSchedules" && (
              <div className="position-relative">
                {dayparts.map((daypart, index) => (
                  <div
                    key={index}
                    className="form-group row mt-4 ml-0 position-relative"
                  >
                    <div className="col-md-2 px-0">
                      <DatepickerD
                        onChange={(date) =>
                          handleTimeChange(index, "startDate", date)
                        }
                        value={daypart.startDate || ""}
                        onBlur={() => { }}
                        setting={formFeildsDayPart[formFeildsDayPart.startDate.key]}
                        error={errors[formFeildsDayPart.startDate.key]}
                        submited={submited}
                        touched={touched[formFeildsDayPart.startDate.key]}
                        // minDate={new Date()}
                        // maxDate={form.end == "" ? new Date() : form.endDate}
                        minDate={defaultCampaignMinDate}
                        maxDate={campaignMaxDate}
                        showDisabledMonthNavigation
                        disabled={props.id ? true : false}
                      // other props
                      />
                    </div>
                    <div className="col-md-2 pr-0">
                      <DatepickerD
                        onChange={(date) =>
                          handleTimeChange(index, "endDate", date)
                        }
                        value={daypart.endDate || ""}
                        onBlur={() => { }}
                        setting={formFeildsDayPart[formFeildsDayPart.endDate.key]}
                        error={errors[formFeildsDayPart.endDate.key]}
                        submited={submited}
                        touched={touched[formFeildsDayPart.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        // minDate={
                        //   props.id
                        //     ? new Date()
                        //     : form.startDate == ""
                        //       ? new Date()
                        //       : form.startDate
                        // }
                        minDate={defaultCampaignMinDate}
                        maxDate={campaignMaxDate}
                        sDate={form.startDate ? form.startDate : form.sDate ? form.sDate : ""}
                      // sDate={form.startDate}
                      // other props
                      />
                    </div>
                    <div className="col-md-4 pt-2">
                      <label className="mr-2">Select Day</label>
                      <div className=" d-flex align-items-center pt-1">
                        <div
                          className="mx-2 circle-checkbox"
                          onClick={() => handleDayChange(index, "sunday")}
                          style={{
                            backgroundColor: daypart.selectedDays.includes(
                              "sunday"
                            )
                              ? "#303890"
                              : "white",
                            color: daypart.selectedDays.includes("sunday")
                              ? "white"
                              : "#707B8A",
                          }}
                        >
                          S
                        </div>
                        <div
                          className="mx-2 circle-checkbox"
                          onClick={() => handleDayChange(index, "monday")}
                          style={{
                            backgroundColor: daypart.selectedDays.includes(
                              "monday"
                            )
                              ? "#303890"
                              : "white",
                            color: daypart.selectedDays.includes("monday")
                              ? "white"
                              : "#707B8A",
                          }}
                        >
                          M
                        </div>
                        <div
                          className="mx-2 circle-checkbox"
                          onClick={() => handleDayChange(index, "tuesday")}
                          style={{
                            backgroundColor: daypart.selectedDays.includes(
                              "tuesday"
                            )
                              ? "#303890"
                              : "white",
                            color: daypart.selectedDays.includes("tuesday")
                              ? "white"
                              : "#707B8A",
                          }}
                        >
                          T
                        </div>
                        <div
                          className="mx-2 circle-checkbox"
                          onClick={() => handleDayChange(index, "wednesday")}
                          style={{
                            backgroundColor: daypart.selectedDays.includes(
                              "wednesday"
                            )
                              ? "#303890"
                              : "white",
                            color: daypart.selectedDays.includes("wednesday")
                              ? "white"
                              : "#707B8A",
                          }}
                        >
                          W
                        </div>
                        <div
                          className="mx-2 circle-checkbox"
                          onClick={() => handleDayChange(index, "thursday")}
                          style={{
                            backgroundColor: daypart.selectedDays.includes(
                              "thursday"
                            )
                              ? "#303890"
                              : "white",
                            color: daypart.selectedDays.includes("thursday")
                              ? "white"
                              : "#707B8A",
                          }}
                        >
                          T
                        </div>
                        <div
                          className="mx-2 circle-checkbox"
                          onClick={() => handleDayChange(index, "friday")}
                          style={{
                            backgroundColor: daypart.selectedDays.includes(
                              "friday"
                            )
                              ? "#303890"
                              : "white",
                            color: daypart.selectedDays.includes("friday")
                              ? "white"
                              : "#707B8A",
                          }}
                        >
                          F
                        </div>
                        <div
                          className="mx-2 circle-checkbox"
                          onClick={() => handleDayChange(index, "saturday")}
                          style={{
                            backgroundColor: daypart.selectedDays.includes(
                              "saturday"
                            )
                              ? "#303890"
                              : "white",
                            color: daypart.selectedDays.includes("saturday")
                              ? "white"
                              : "#707B8A",
                          }}
                        >
                          S
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 pt-2">
                      <label className="mr-2">Select Time</label>
                      <div className="d-flex align-items-center mb-3">
                        <SelectNew
                          onChange={(e) =>
                            handleTimeChange(index, "startTime", e.target.value)
                          }
                          onBlur={(e) => {
                            // handleTouch(e);
                          }}
                          value={daypart.startTime}
                          setting={
                            formFeildsTimeKey[formFeildsTimeKey.startTime.key]
                          }
                          error={{}}
                          submited={false}
                          touched={{}}
                          options={optionsData.startTimeOptions}
                        // disabled={isEdit}
                        />

                        <SelectNew
                          onChange={(e) =>
                            handleTimeChange(index, "endTime", e.target.value)
                          }
                          onBlur={(e) => {
                            // handleTouch(e);
                          }}
                          value={daypart.endTime}
                          setting={
                            formFeildsTimeKey[formFeildsTimeKey.endTime.key]
                          }
                          error={{}}
                          submited={false}
                          touched={{}}
                          options={optionsData.endTimeOptions}
                        // disabled={isEdit}
                        />
                      </div>
                    </div>
                    {index > 0 && (
                      <button
                        className="btn btn-danger delete-circular-btn"
                        onClick={() => handleDeleteRow(index)}
                      >
                        <i className="mdi mdi-delete mr-0"></i>
                      </button>
                    )}
                  </div>
                ))}
                <button
                  className="btn btn-primary circular-btn-daypart"
                  onClick={handleAddRow}
                >
                  +
                </button>
              </div>
            )}
          </div>
        </CSSTransition>

        <CSSTransition
          in={showPageForm}
          timeout={300}
          classNames="form-transition"
          unmountOnExit
        >
          <div className="row">
            <div className="form-group row mb-0">
              <label for="agegroup" class="col-12 col-form-label">
                Page (Meta)
                {/* <span class="text-danger">*</span> */}
              </label>
            </div>
            <div className="col-md-6 ">
              <SelectNew
                onChange={handleChange}
                onBlur={handleTouch}
                value={form[formFeildfacebookPageList.fbPageAccount.key]}
                setting={formFeildfacebookPageList[formFeildfacebookPageList.fbPageAccount.key]}
                error={errors[formFeildfacebookPageList.fbPageAccount.key]}
                submited={submited}
                touched={touched[formFeildfacebookPageList.fbPageAccount.key]}
                options={seatData}
                infoIcon={infoButtonBooleanData[infoKeys.selectAccount]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.selectAccount]
                  );
                }}
              />
            </div>
            <div className="col-md-6 ">
              <SelectNew
                onChange={handleChange}
                onBlur={handleTouch}
                value={form[formFeildfacebookPageList.fbPageList.key]}
                setting={formFeildfacebookPageList[formFeildfacebookPageList.fbPageList.key]}
                error={errors[formFeildfacebookPageList.fbPageList.key]}
                submited={submited}
                touched={touched[formFeildfacebookPageList.fbPageList.key]}
                options={fbPageData}
                infoIcon={infoButtonBooleanData[infoKeys.selectPage]}
                onInfoClick={() => {
                  openInformationModal(
                    strategyInfoData[infoKeys.selectPage]
                  );
                }}
              />
            </div>
          </div>
        </CSSTransition>
      </div>

      <div className="strategy-bottom-bar set-preference-adj">


        <CSSTransition
          in={!showLocationForm}
          timeout={{ enter: 300, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("location", setShowLocationForm)}
          >
            Add Location
          </div>
        </CSSTransition>
        <CSSTransition
          in={!showAudienceForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("audience", setShowAudienceForm)}
          >
            Add Audience
          </div>
        </CSSTransition>
        <CSSTransition
          in={!showKeywordsForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("keywords", setShowKeywordsForm)}
          >
            Add Keywords
          </div>
        </CSSTransition>
        <CSSTransition
          in={!showSitesForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div
            onClick={() => handleAddFormClick("sites", setShowSitesForm)}
          >
            Add Sites
          </div>
        </CSSTransition>
        <CSSTransition
          in={!showOnScreenPositionForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <>
            {
              // ['ion', 'meta', 'dv360'].includes(props.platformType.toString()) &&
              <div onClick={() => handleAddFormClick("onScreenPosition", setShowOnScreenPositionForm)}>
                Onscreen Position Details
              </div>
            }
          </>
        </CSSTransition>
        <CSSTransition
          in={!showFlightForm}
          timeout={{ enter: 400, exit: 200 }}
          classNames="button-transition"
          unmountOnExit
        >
          <div onClick={() => handleAddFormClick("flight", setShowFlightForm)}>
            Flight(Dayparting)
          </div>
        </CSSTransition>
        {
          platformKeys.includes("meta") &&

          <CSSTransition
            in={!showPageForm}
            timeout={{ enter: 400, exit: 200 }}
            classNames="button-transition"
            unmountOnExit
          >
            <div onClick={() => handleAddFormClick("page", setShowPageForm)}>
              Page (Meta)
            </div>
          </CSSTransition>

        }
      </div>
    </>
  );
};

export default withRouter(Strategy);
